import { Dialog, DialogPanel, Transition, TransitionChild, Combobox, DialogTitle, ComboboxOptions, ComboboxOption, ComboboxInput } from "@headlessui/react";
import { Fragment, useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import Button from "../Button";

interface FilterData {
    query: string;
    threshold?: string;
    description?: string;
    name?: string;
    key?: string;
}

interface FiltersOffcanvasProps {
    isOpen: boolean;
    onClose: (value: boolean) => void;
    selectedFilter?: string | null;
    onExampleClick: (query: string) => void;
    activeEducationElementId: string | null;
    filterButtonPlaceholder: string;
    isScreenerComp: boolean;
    onQuerySubmit: (data: FilterData | FilterData[]) => void;
}

const filterSuggestions = [
    // {
    //     "name": "Exchange",
    //     "key": "exchange"
    // },
    {
        "name": "Market Cap",
        "key": "market_cap"
    },
    {
        "name": "Number of Employees",
        "key": "number_of_employees"
    },
    {
        "name": "industry",
        "key": "industry"

    },
    {
        "name": "sector",
        "key": "sector"
    },
    {
        "name": "Is Founder CEO",
        "key": "founder_ceo_operator"
    },
    {
        "name": "city",
        "key": "city"
    },
    {
        "name": "State Province Value",
        "key": "state_province_value"
    },
    {
        "name": "Country",
        "key": "country_value"
    },
    {
        "name": "Price to Sales Ratio",
        "key": "price_to_sales_ratio_ttm"
    },
    {
        "name": "Price To Book Ratio",
        "key": "price_to_book_ratio"
    },
    {
        "name": "Dividend Yield",
        "key": "dividend_yield_value_ttm"
    },
    {
        "name": "Founded Year",
        "key": "founded_year"
    },
    {
        "name": "Glassdoor Overall Rating",
        "key": "glassdoor_overall_rating"
    },
    {
        "name": "Glassdoor CEO Approval Rating",
        "key": "glassdoor_ceo_approval_rating"
    },
    {
        "name": "Glassdoor Friend Recommendation Percent",
        "key": "glassdoor_friend_recommendation_percent"
    },
    {
        "name": "Total Assets",
        "key": "total_assets"
    },
    {
        "name": "Total Current Assets",
        "key": "total_current_assets"
    },
    {
        "name": "Total Non-Current Assets",
        "key": "total_non_current_assets"
    },
    {
        "name": "Total Liabilities",
        "key": "total_liabilities"
    },
    {
        "name": "Total Current Liabilities",
        "key": "total_current_liabilities"
    },
    {
        "name": "Total Non-Current Liabilities",
        "key": "total_non_current_liabilities"
    },
    {
        "name": "Total Equity",
        "key": "total_equity"
    },
    {
        "name": "Gross Profit Margin",
        "key": "gross_profit_margin_ttm"
    },
    {
        "name": "Net Profit Margin",
        "key": "net_profit_margin_ttm"
    },
    {
        "name": "Operating Profit Margin",
        "key": "operating_profit_margin_ttm"
    },
    {
        "name": "Price to Earnings Growth Ratio",
        "key": "price_to_earnings_growth_ratio_ttm"
    },
    {
        "name": "Trailing Price to Earnings Ratio",
        "key": "trailing_pe"
    },
    {
        "name": "Forward Price To Earnings Ratio",
        "key": "forward_pe"
    },
    {
        "name": "Revenue Per Share TTM",
        "filter_type": "revenue_per_share_ttm",
        "key": "revenue_per_share_ttm"
    },
    {
        "name": "Enterprise Value TTM",
        "key": "enterprise_value_ttm"
    },
    {
        "name": "Book Value Per Share TTM",
        "key": "book_value_per_share_ttm"
    },
    {
        "name": "EBITDA",
        "key": "ebitda"
    },
    {
        "name": "Return on Assets",
        "key": "return_on_assets_ttm"
    },
    {
        "name": "Return on Equity",
        "key": "return_on_equity_ttm"
    },
    {
        "name": "Return on Investment",
        "key": "return_on_investment_ttm"
    },
    {
        "name": "Shares Short Float Percentage",
        "key": "short_percent"
    },
    {
        "name": "Analyst Ratings (Strong Buy Percentage)",
        "key": "analyst_strong_buy_percentage"
    },
    {
        "name": "Analyst Ratings (Buy Percentage)",
        "key": "analyst_buy_percentage"
    },
    {
        "name": "Analyst Ratings (Hold Percentage)",
        "key": "analyst_hold_percentage"
    },
    {
        "name": "Analyst Ratings (Sell Percentage)",
        "key": "analyst_sell_percentage"
    },
    {
        "name": "Analyst Ratings (Strong Sell Percentage)",
        "key": "analyst_strong_sell_percentage"
    },
    {
        "name": "Insider Shares Ownership Percentage",
        "key": "insiders_shares_hold_percent"
    },
    {
        "name": "Institutional Shares Hold Percent",
        "key": "institutions_shares_hold_percent"
    },
    {
        "name": "eps",
        "key": "eps_ttm"
    },
    {
        "name": "Institutional Holders",
        "key": "institutional_holders"
    },
    {
        "name": "Price To Earnings Ratio",
        "key": "price_to_earnings_ratio"
    },
    {
        "name": "Average Revenue Growth 6Q",
        "key": "avg_revenue_growth_6q"
    },
    {
        "name": "Average Revenue Growth 4Q",
        "key": "avg_revenue_growth_4q"
    },
    {
        "name": "Average Revenue Growth 1Y",
        "key": "avg_revenue_growth_1y"
    },
    {
        "name": "Average Revenue Growth 2Y",
        "key": "avg_revenue_growth_2y"
    },
    {
        "name": "Average Revenue Growth 3Y",
        "key": "avg_revenue_growth_3y"
    },
    {
        "name": "Average Revenue Growth 4Y",
        "key": "avg_revenue_growth_4y"
    },
    {
        "name": "Average Revenue Growth 5Y",
        "key": "avg_revenue_growth_5y"
    },
    {
        "name": "Average Net Income Growth 1Y",
        "key": "avg_net_income_growth_1y"
    },
    {
        "name": "Average Net Income Growth 2Y",
        "key": "avg_net_income_growth_2y"
    },
    {
        "name": "Average Net Income Growth 3Y",
        "key": "avg_net_income_growth_3y"
    },
    {
        "name": "Average Net Income Growth 4Y",
        "key": "avg_net_income_growth_4y"
    },
    {
        "name": "Average Net Income Growth 5Y",
        "key": "avg_net_income_growth_5y"
    },
    {
        "name": "Average Net Income Growth 6Q",
        "key": "avg_net_income_growth_6q"
    },
    {
        "name": "Debt To Equity",
        "key": "debt_to_equity"
    },
    {
        "name": "Payout Ratio",
        "key": "pay_out_ratio"
    },
    {
        "name": "Average Gross Profit Growth 1Y",
        "key": "avg_gross_profit_growth_1y"
    },
    {
        "name": "Average Gross Profit Growth 2Y",
        "key": "avg_gross_profit_growth_2y"
    },
    {
        "name": "Average Gross Profit Growth 3Y",
        "key": "avg_gross_profit_growth_3y"
    },
    {
        "name": "Average Gross Profit Growth 4Y",
        "key": "avg_gross_profit_growth_4y"
    },
    {
        "name": "Average Gross Profit Growth 5Y",
        "key": "avg_gross_profit_growth_5y"
    },
    {
        "name": "Average Gross Profit Growth 6Q",
        "key": "avg_gross_profit_growth_6q"
    },
    {
        "name": "Total Acquired 1 Month",
        "key": "total_acquired_1_month"
    },
    {
        "name": "Total Acquired 2 Month",
        "key": "total_acquired_2_month"
    },
    {
        "name": "Total Acquired 3 Month",
        "key": "total_acquired_3_month"
    },
    {
        "name": "Total Disposed 1 Month",
        "key": "total_disposed_1_month"
    },
    {
        "name": "Total Disposed 2 Month",
        "key": "total_disposed_2_month"
    },
    {
        "name": "Total Disposed 3 Month",
        "key": "total_disposed_3_month"
    },
    {
        "name": "Free Cash Flow Avg 4Q",
        "key": "free_cash_flow_avg_4q"
    },
    {
        "name": "Free Cash Flow Avg 6Q",
        "key": "free_cash_flow_avg_6q"
    },
    {
        "name": "Revenue Last Quarter",
        "key": "revenue_last_quarter"
    },
    {
        "name": "Net Income Last Quarter",
        "key": "net_income_last_quarter"
    },
    {
        "name": "Gross Profit Last Quarter",
        "key": "gross_profit_last_quarter"
    },
    {
        "name": "Revenue TTM",
        "key": "revenue_ttm"
    },
    {
        "name": "Net Income TTM",
        "key": "net_income_ttm"
    },
    {
        "name": "Gross Profit TTM",
        "key": "gross_profit_ttm"
    },
    {
        "name": "Recent Insider Activity",
        "key": "recent_insider_activity"
    },
    {
        "name": "Free Cash Flow TTM",
        "key": "free_cash_flow_ttm"
    },
    {
        "name": "IPO Year",
        "key": "ipo_year"
    }
];

export const FiltersOffcanvas: React.FC<FiltersOffcanvasProps> = ({ isOpen, onClose, selectedFilter = null, onExampleClick, activeEducationElementId, filterButtonPlaceholder, isScreenerComp, onQuerySubmit }) => {

    const [filterQueryValue, setFilterQueryValue] = useState("");
    const [showFilterSuggestions, setShowFilterSuggestions] = useState(activeEducationElementId ? false : true);
    const [narrowedSuggestions, setNarrowedSuggestions] = useState<any[]>([]);
    const [activeSuggestion, setActiveSuggestion] = useState(0);
    const [filterTextBoxQueryValue, setFilterTextBoxQueryValue] = useState(activeEducationElementId ? activeEducationElementId : "");
    let textValue = "";
    const inputRef = useRef<HTMLInputElement>(null);
    const suggestionsRef = useRef<HTMLDivElement>(null);


    useEffect(() => {
        if (showFilterSuggestions) filterLineItems();
    }, [filterTextBoxQueryValue, showFilterSuggestions, textValue]);

    useEffect(() => {
        if (isOpen) {
            const timer = setTimeout(() => {
                if (!activeEducationElementId) {
                    if (inputRef.current) {
                        inputRef.current.focus();
                    }
                }

            }, 100);
            if (activeEducationElementId) {
                setFilterQueryValue(activeEducationElementId);
                setFilterTextBoxQueryValue(activeEducationElementId);
                setShowFilterSuggestions(false);
            }
            return () => clearTimeout(timer);
        }
    }, [isOpen]);


    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            // Ignore clicks on the offcanvas dialog
            const isOffcanvasClick = (event.target as Element).closest('[role="dialog"]');
            if (isOffcanvasClick) return;

            if (suggestionsRef.current && !suggestionsRef.current.contains(event.target as Node)) {
                //   setShowSuggestions(false);
                setActiveSuggestion(-1);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (activeSuggestion >= 0 && narrowedSuggestions.length > 0) {
            const suggestionsList = document.querySelector('.suggestions-list');
            const selectedElement = suggestionsList?.children[activeSuggestion] as HTMLElement;

            if (selectedElement && suggestionsList) {
                const containerHeight = suggestionsList.clientHeight;
                const scrollTop = suggestionsList.scrollTop;
                const elementTop = selectedElement.offsetTop;
                const elementHeight = selectedElement.offsetHeight;

                // Scroll down if element is below viewport
                if (elementTop + elementHeight > scrollTop + containerHeight) {
                    suggestionsList.scrollTop = elementTop + elementHeight - containerHeight;
                }
                // Scroll up if element is above viewport
                else if (elementTop < scrollTop) {
                    suggestionsList.scrollTop = elementTop;
                }
            }
        }
    }, [activeSuggestion, narrowedSuggestions]);
    // Function to perform the fuzzy filtering of suggestions
    function filterLineItems() {
        if (!showFilterSuggestions) {
            setNarrowedSuggestions([]);
            return;
        }

        if (!filterTextBoxQueryValue) {
            // Reset to the original data if search is empty
            setNarrowedSuggestions(filterSuggestions);
        } else {
            const filteredInfoSuggestions = filterSuggestions.filter(filterSuggestItem => {

                const lowerCaseSearchQuery = filterTextBoxQueryValue.toLowerCase();
                if (filterSuggestItem.name.toLowerCase().includes(lowerCaseSearchQuery)) {
                    return true; // Found a match in the key
                }
            });

            setNarrowedSuggestions(filteredInfoSuggestions);
        }
    };

    const handleFilterQueryChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        //  setFilterQueryValue(inputValue);
        setFilterTextBoxQueryValue(inputValue);
        setShowFilterSuggestions(true);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (narrowedSuggestions.length === 0) return;

        switch (event.key) {
            case 'ArrowUp':
                setActiveSuggestion((prev) => (prev > 0 ? prev - 1 : narrowedSuggestions.length - 1));
                break;
            case 'ArrowDown':
                setActiveSuggestion((prev) => (prev < narrowedSuggestions.length - 1 ? prev + 1 : 0));
                break;
            case 'Enter':
                if (activeSuggestion >= 0 && activeSuggestion < narrowedSuggestions.length) {
                    const selectedSuggestion = narrowedSuggestions[activeSuggestion];
                    // setFilterTextBoxQueryValue("")
                    setFilterTextBoxQueryValue(selectedSuggestion.key)
                    setFilterQueryValue(selectedSuggestion.key);
                    setShowFilterSuggestions(false);
                }
                break;
            case 'Backspace':

                if (filterTextBoxQueryValue.length === 1) {
                    // setFilterQueryValue((prevState)=>{
                    //     setFilterTextBoxQueryValue(filterQueryValue)
                    //     return '';
                    // });
                    setFilterTextBoxQueryValue("");
                }

                break;
            default:

                return;
        }
    };

    const handleOnBlur = () => {
        setTimeout(() => {
            setShowFilterSuggestions(false);
        }, 200);
    };

    const handleSuggestionClick = (suggestItem: any) => {

        setFilterTextBoxQueryValue(suggestItem.key);
        setFilterQueryValue(suggestItem.key);
        textValue = suggestItem.key;

        setShowFilterSuggestions(false);
    };

    const handleClose = () => {
        onClose(false);
        setFilterQueryValue("");
        setFilterTextBoxQueryValue("");
        setShowFilterSuggestions(false)
        setNarrowedSuggestions([]);
        setActiveSuggestion(0);
    };

    const onChildPropClick = (queryValue: string) => {

        if (isScreenerComp) {
            onExampleClick(queryValue || '');
            setFilterQueryValue("")
            setFilterTextBoxQueryValue("")
            setShowFilterSuggestions(false)
            setNarrowedSuggestions([])
            setActiveSuggestion(0)
        } else {
            let queryKey = queryValue.split(' ')[0];
            onQuerySubmit({ query: queryValue || '', threshold: '', description: '', name: '', key: queryKey });
            setFilterQueryValue("")
            setFilterTextBoxQueryValue("")
            setShowFilterSuggestions(false)
            setNarrowedSuggestions([])
            setActiveSuggestion(0)
            onClose(false);
        }
    }

    const sections = {
        'market_cap': (
            <div id="market-cap-info-section" className="education-info-section mb-5 text-gray-700 text-gray-700" data-suggest-name="Market Capitalization (Market Cap) style={{ overflowY: 'auto', maxHeight: '400px' }}">
                <p className="text-lg font-semibold mb-4">Market Capitalization (Market Cap)</p>
                <p className="text-sm mb-4">
                    Market capitalization, commonly known as market cap, is a measure of the total value of a publicly traded company's outstanding shares of stock. It is calculated by multiplying the current market price per share by the total number of outstanding shares. Market cap gives investors an idea of a company's size in the stock
                    market and is often used to compare companies.
                </p>
                <p className="text-sm mb-4">
                    The formula for calculating market cap is:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Market Cap = Current Market Price per Share X Total Number of Outstanding Shares
                </div>
                <p className="text-sm mb-4">
                    Below are the sample queries for market cap:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">Market Cap {'>='} 10M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('market_cap >= 10M')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">Market Cap {'>='} 10B</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('market_cap >= 10B')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">Market Cap {'>='} 1T</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('market_cap >= 1T')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    Market cap is used to categorize companies into different size classes, such as large-cap, mid-cap, and
                    small-cap. Here's a breakdown of these classifications:
                </p>
                <ol className="list-decimal text-sm mb-4 leading-6 ml-4">
                    <li><strong>Large-cap:</strong> Market cap typically greater than $10 billion.</li>
                    <li><strong>Mid-cap:</strong> Market cap between $2 billion and $10 billion.</li>
                    <li><strong>Small-cap:</strong> Market cap between $300 million and $2 billion.</li>
                </ol>
                <p className="text-sm mb-4">
                    Investors use market cap as one of many factors to assess a company's investment potential, risk, and overall
                    market position. Keep in mind that market cap alone doesn't provide a complete picture of a company's financial health or potential for growth; it is just one of many metrics investors consider.
                </p>
            </div>
        ),
        'price_to_sales_ratio_ttm': (
            <div id="price-to-sales-ratio-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Price to Sales Ratio (TTM)">
                <p className="text-lg font-semibold mb-4">Price to Sales Ratio (TTM)</p>
                <p className="text-sm mb-4">
                    The Price to Sales Ratio (P/S Ratio), measured on a trailing twelve months (TTM) basis, is a valuation metric that compares a company's stock price to its revenues. It helps investors determine how much they
                    are paying for every dollar of a company's sales. A lower P/S ratio could suggest that the stock is undervalued relative to its sales, while a higher P/S ratio might indicate overvaluation.
                </p>
                <p className="text-sm mb-4">
                    The formula for calculating the Price to Sales Ratio is:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    P/S Ratio = Market Capitalization / Total Revenue
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the Price to Sales Ratio (TTM):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">Price to Sales Ratio {'<'} 1</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('price_to_sales_ratio_ttm < 1')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">Price to Sales Ratio {'>'} 4</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('price_to_sales_ratio_ttm > 4')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <ol className="list-decimal text-sm mb-4 leading-6 ml-4">
                    <li><strong>High P/S Ratio:</strong> Often found in high-growth companies, indicating high future growth expectations from investors.</li>
                    <li><strong>Moderate P/S Ratio:</strong> Typically seen in stable, fairly valued companies, suggesting that the stock is reasonably priced relative to its sales.</li>
                    <li><strong>Low P/S Ratio:</strong> Common in companies facing operational or industry challenges, indicating potential undervaluation or inherent risks.</li>
                </ol>
                <p className="text-sm mb-4">
                    Investors typically use the P/S Ratio to identify potential investment opportunities, where a lower P/S ratio might suggest that a company is undervalued relative to its sales.
                </p>
            </div>
        ),
        'founder_ceo_operator': (
            <div id="founder-ceo-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Founder / CEO">
                <p className="text-lg font-semibold mb-4">Founder / CEO</p>
                <p className="text-sm mb-4">
                    Founder / CEO refers to the individual or individuals who founded a company and hold the position of Chief Executive Officer (CEO). The founder is typically the person who conceived the idea for the company and played a key role in its establishment and early growth stages.
                </p>
                <p className="text-sm mb-4">
                    The CEO, on the other hand, is responsible for leading the company, making strategic decisions, and overseeing its overall operations and performance. In many cases, the founder and CEO may be the same person, especially in startups and smaller companies.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the founder / CEO:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">founder_ceo_operator = true</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('founder_ceo_operator = true')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">founder_ceo_operator = false</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('founder_ceo_operator = false')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    Understanding the background and leadership of the founder / CEO can provide insights into the company's vision, culture, and direction, which are important factors for investors and stakeholders to consider.
                </p>
            </div>
        ),
        'price_to_book_ratio': (
            <div id="price-to-book-ratio-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Price to Book Ratio (TTM)">
                <p className="text-lg font-semibold mb-4">Price to Book Ratio (TTM)</p>
                <p className="text-sm mb-4">
                    The Price to Book Ratio (P/B Ratio), also known as the market-to-book ratio, is a financial ratio used to compare a company's current market price to its book value. The ratio indicates how much shareholders are paying for each dollar of net assets.
                </p>
                <p className="text-sm mb-4">
                    The formula for calculating the Price to Book Ratio is:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    P/B Ratio = Current Stock Price / Book Value per Share (TTM)
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the Price to Book Ratio (TTM):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">Price to Book Ratio {'<'} 1</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('price_to_book_ratio < 1')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">Price to Book Ratio {'>'} 3</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('price_to_book_ratio > 3')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <ol className="list-decimal text-sm mb-4 leading-6 ml-4">
                    <li><strong>High P/B Ratio:</strong> A ratio above 3 indicates strong market valuation due to growth potential or significant intangible assets..</li>
                    <li><strong>Moderate P/B Ratio:</strong> A ratio between 1 and 3 suggests a reasonable valuation relative to the company's book value.</li>
                    <li><strong>Low P/B Ratio:</strong> A ratio below 1 may signal undervaluation, possibly due to market downturns or industry challenges.</li>
                </ol>
                <p className="text-sm mb-4">
                    This metric provides an additional layer of depth to traditional asset valuation, offering a timely perspective that might better reflect current market conditions and company specifics.
                </p>
            </div>

        ),
        'dividend_yield': (
            <div id="dividend-yield-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Dividend Yield (TTM)">
                <p className="text-lg font-semibold mb-4">Dividend Yield (TTM)</p>
                <p className="text-sm mb-4">
                    The Dividend Yield Value (TTM) measures the percentage of a company's stock price that shareholders receive as dividends over the trailing twelve months, expressed as a percentage.
                </p>
                <p className="text-sm mb-4">
                    The formula for calculating Dividend Yield is:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Dividend Yield (TTM) = (Total Dividends per Share over the Last 12 Months / Current Stock Price) × 100
                </div>
                <p className="text-sm mb-4">
                    Below are the sample queries for Dividend Yield:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">Dividend Yield {'>='} 3%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('dividend_yield >= 3%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">Dividend Yield {'>='} 5%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('dividend_yield >= 5%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    <strong>Potential pitfalls and limitations</strong>
                </p>
                <ol className="list-decimal text-sm mb-4 leading-6 ml-4">
                    <li><strong>Not a standalone metric:</strong> High yields can sometimes reflect a declining stock price, not just generous dividends.</li>
                    <li><strong>Sustainability issues:</strong> Investors should evaluate whether high yields are sustainable by checking the payout ratio.</li>
                    <li><strong>Sensitive to market conditions:</strong> Fluctuations in economic factors like interest rates can alter the attractiveness of dividend yields.</li>
                </ol>
            </div>
        ),
        'city': (
            <div id="city-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="City">
                <p className="text-lg font-semibold mb-4">City</p>
                <p className="text-sm mb-4">
                    Information about the city where company is located.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the city:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">City = Vancouver</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('city = Vancouver')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">City = Atlanta</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('city = Atlanta')}
                    >{filterButtonPlaceholder}</Button>
                </div>

            </div>
        ),
        'state_province_value': (
            <div id="city-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="City">
                <p className="text-lg font-semibold mb-4">state_province_value</p>
                <p className="text-sm mb-4">
                    Information about the province where comapny is located goes here.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the state_province_value:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">state_province_value = VA</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('state_province_value = VA')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">state_province_value = AZ</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('state_province_value = AZ')}
                    >{filterButtonPlaceholder}</Button>
                </div>

            </div>
        ),
        'country_value': (
            <div id="country-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Country">
                <p className="text-lg font-semibold mb-4">Country</p>
                <p className="text-sm mb-4">
                    Information about the country where company is located.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the country:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">Country = United States</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('country_value = US')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">Country = Japan</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('country_value = JP')}
                    >{filterButtonPlaceholder}</Button>
                </div>
            </div>
        ),
        'founded_year': (
            <div id="founded-year-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Founded Year">
                <p className="text-lg font-semibold mb-4">Founded Year</p>
                <p className="text-sm mb-4">
                    Founded year refers to the year in which a company was established or incorporated. It represents the year when the company was founded and began its operations.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the founded year:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">Founded Year {'<'}= 2000</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('founded_year <= 2000')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">Founded Year {'>'} 2010</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('founded_year > 2010')}
                    >{filterButtonPlaceholder}</Button>
                </div>

            </div>
        ),
        'ipo_date': (
            <div id="ipo-date-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="IPO Date">
                <p className="text-lg font-semibold mb-4">IPO Date</p>
                <p className="text-sm mb-4">
                    IPO Date refers to the date on which a company's shares are first offered to the public through an initial public offering (IPO). It marks the transition from a privately held company to a publicly traded company with shares available for purchase by investors on a stock exchange.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the IPO date:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">IPO Date = 2020-01-01</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('ipo_date = 2020-01-01')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">IPO Date {'>'} 2015-01-01</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('ipo_date > 2015-01-01')}
                    >{filterButtonPlaceholder}</Button>
                </div>
            </div>
        ),
        'number_of_employees': (
            <div id="number-of-employees-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Number of Employees">
                <p className="text-lg font-semibold mb-4">Number of Employees</p>
                <p className="text-sm mb-4">
                    Number of employees refers to the total count of individuals employed by a company. It is an important metric that indicates the size and scale of the workforce within a company.
                </p>
                <p className="text-sm mb-4">
                    The number of employees can vary significantly across companies and industries. Larger companies tend to have more employees, while smaller companies may have fewer employees.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the number of employees:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">Number of Employees {'>='} 1000</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('number_of_employees >= 1000')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">Number of Employees {'>'} 5000</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('number_of_employees >= 5000')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">Number of Employees {'<='} 10000</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('number_of_employees >= 10000')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    The number of employees is often used by investors and analysts to assess a company's size, operational capacity, and potential for growth. However, it is important to consider other factors alongside the number of employees when evaluating a company's performance and prospects.
                </p>
            </div>
        ),
        'glassdoor_overall_rating': (
            <div id="glassdoor-overall-rating-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Glassdoor Overall Rating">
                <p className="text-lg font-semibold mb-4">Glassdoor Overall Rating</p>
                <p className="text-sm mb-4">
                    Glassdoor Overall Rating is a metric that reflects the overall satisfaction and sentiment of current and former employees towards a company. It is based on anonymous reviews and ratings provided by employees on the Glassdoor platform. It is rated on a scale of 1 to 5.
                </p>
                <p className="text-sm mb-4">
                    The Glassdoor Overall Rating is typically displayed as a numerical value on a scale of 1 to 5, with 1 being the lowest rating and 5 being the highest rating. It provides insights into the company's work environment, culture, management, and employee experiences.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the Glassdoor Overall Rating:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">Glassdoor Overall Rating {'>'} 4</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('glassdoor_overall_rating > 4')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">Glassdoor Overall Rating {'<='} 3</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('glassdoor_overall_rating <= 3')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    The Glassdoor Overall Rating can provide valuable insights for job seekers, employees, and potential investors to evaluate a company's workplace culture, employee satisfaction, and overall reputation within the industry.
                </p>
            </div>
        ),
        'glassdoor_ceo_approval_rating': (
            <div id="glassdoor-ceo-approval-rating-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Glassdoor CEO Approval Rating">
                <p className="text-lg font-semibold mb-4">Glassdoor CEO Approval Rating</p>
                <p className="text-sm mb-4">
                    Glassdoor CEO Approval Rating is a metric that reflects the percentage of employees who approve of their CEO's leadership and performance. It is based on anonymous reviews and ratings provided by employees on the Glassdoor platform.
                </p>
                <p className="text-sm mb-4">
                    The Glassdoor CEO Approval Rating is typically displayed as a percentage value, representing the proportion of employees who approve of the CEO's leadership. A higher approval rating indicates greater employee satisfaction and confidence in the CEO's abilities.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the Glassdoor CEO Approval Rating:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">Glassdoor CEO Approval Rating {'>'} 90%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('glassdoor_ceo_approval_rating > 90%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">Glassdoor CEO Approval Rating {'<='} 70%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('glassdoor_ceo_approval_rating <= 70%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    The Glassdoor CEO Approval Rating provides valuable insights into employee sentiment, leadership effectiveness, and organizational culture within a company. It can help job seekers, employees, and investors assess the quality of leadership and management within an organization.
                </p>
            </div>
        ),
        'glassdoor_friend_recommendation_percent': (
            <div id="glassdoor-friend-recommendation-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Glassdoor Friend Recommend Percentage">
                <p className="text-lg font-semibold mb-4">Glassdoor Friend Recommend Percentage</p>
                <p className="text-sm mb-4">
                    Glassdoor Friend Recommend Percentage is a metric that reflects the percentage of employees who would recommend their company to a friend as a great place to work. It is based on anonymous reviews and ratings provided by employees on the Glassdoor platform.
                </p>
                <p className="text-sm mb-4">
                    The Glassdoor Friend Recommend Percentage is typically displayed as a percentage value, representing the proportion of employees who would recommend their company to others. A higher recommendation percentage indicates greater employee satisfaction and positive experiences at the company.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the Glassdoor Friend Recommend Percentage:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">Glassdoor Friend Recommend Percentage {'>'} 80%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('glassdoor_friend_recommendation_percent > 80%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span className="mt-1">Glassdoor Friend Recommend Percentage {'<='} 60%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('glassdoor_friend_recommendation_percent <= 60%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    The Glassdoor Friend Recommend Percentage provides valuable insights into employee satisfaction, workplace culture, and the overall employee experience within a company. It can help job seekers, employees, and investors assess the quality of work environment and employee relationships.
                </p>
            </div>
        ),
        'total_assets': (
            <div id="total-assets-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Total Assets">
                <p className="text-lg font-semibold mb-4">Total Assets</p>
                <p className="text-sm mb-4">
                    Total Assets refer to the sum of all assets owned by a company, including both current and non-current assets. This figure represents the total resources a company has at its disposal for generating revenue and maintaining operations.                </p>
                <p className="text-sm mb-4">
                    The total assets of a company can provide insights into its financial health, liquidity, and overall value. Investors and analysts use this metric to assess a company's financial strength, stability, and growth potential.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Total Assets:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Total Assets = Total Current Assets + Total Non-Current Assets
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the total assets:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Assets {'>'} 1B</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_assets > 1B')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                    CAGR: Compound Annual Growth Rate
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Assets Growth - past 3 years, CAGR {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_assets_growth_past_3_years_cagr > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Average: Average Gross Profit Margin Growth
                </h3>

                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Assets Growth - past 3 years, Average {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_assets_growth_past_3_years_average > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Total: Total Total Assets growth achieved
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Assets Growth - past 3 years, Total {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_assets_growth_past_3_years_total > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Has Improved: Has Improved Total Assets Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Has Total Assets Improved - past 3 years = True</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('has_total_assets_improved_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    The total assets of a company give a snapshot of its financial scale and resource availability, which is crucial for assessing its overall financial health and operational capabilities.
                </p>
            </div>
        ),
        'total_current_assets': (
            <div id="total-current-assets-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Total Current Assets">
                <p className="text-lg font-semibold mb-4">Total Current Assets</p>
                <p className="text-sm mb-4">
                    Total Current Assets refer to the sum of all current assets owned by a company, including cash, accounts receivable, inventory, and other assets that are expected to be converted into cash within one year. These assets are essential for a company's day-to-day operations and liquidity.
                </p>
                <p className="text-sm mb-4">
                    The total current assets of a company provide insights into its short-term financial health, working capital, and liquidity position. Investors and analysts use this metric to assess a company's ability to meet its short-term obligations and fund its ongoing operations.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Total Current Assets:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Total Current Assets = Cash and Cash Equivalents + Marketable Securities + Accounts Receivable + Inventory + Other Current Assets
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the total current assets:
                </p>

                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Current Assets {'>'} 500M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_current_assets > 500M')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                    CAGR: Compound Annual Growth Rate
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Current Assets Growth - past 3 years, CAGR {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_current_assets_growth_past_3_years_cagr > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Average: Average Total Current Assets Growth
                </h3>

                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Current Assets Growth - past 3 years, Average {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_current_assets_growth_past_3_years_average > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Total:  Total Current Assets growth achieved
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Current Assets Growth - past 3 years, Total {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_current_assets_growth_past_3_years_total > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Has Improved: Has Improved Gross Profit Margin Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Has Total Current Assets Improved - past 3 years = True</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('has_total_current_assets_improved_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    <strong>Potential Pitfalls or Limitations </strong>
                </p>
                <ol className="list-decimal list-inside">
                    <li> <strong> Misleading Liquidity Indicators:</strong> High current assets can be misleading if they predominantly consist of slow-moving inventory or bad debts, which are not as liquid as cash or marketable securities.</li>
                    <li> <strong> Seasonal Fluctuations:</strong>Total current assets can vary significantly due to seasonal business cycles, affecting liquidity assessments based on a single point in time.</li>
                    <li> <strong> Industry Differences: </strong> Asset composition and necessity vary widely by industry. For example, a service company might have less inventory but more receivables than a retail business.</li>
                </ol>
                <p className="text-sm mb-4">
                    Total Current Assets provide crucial insight into a company's short-term financial health, offering an indication of its ability to manage cash flows and meet immediate financial commitments.                </p>
            </div>
        ),
        'total_non_current_assets': (
            <div id="total-non-current-assets-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Total Non-Current Assets">
                <p className="text-lg font-semibold mb-4">Total Non-Current Assets</p>
                <p className="text-sm mb-4">
                    Total Non-Current Assets are the assets that a company intends to hold for more than one fiscal year. These include long-term investments, property, plant and equipment (PPE), intangible assets like patents and trademarks, and other long-term resources.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Total Non-Current Assets:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Total Non-Current Assets =Property, Plant, and Equipment + Long-term Investments + Intangible Assets + Other Non-Current Assets
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the total non-current assets:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Non-Current Assets {'>'} 1B</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_non_current_assets > 1B')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                    CAGR: Compound Annual Growth Rate
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Non-Current Assets Growth - past 3 years, CAGR {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_non_current_assets_growth_past_3_years_cagr > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Average: Average Gross Profit Margin Growth
                </h3>

                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Non-Current Assets Growth - past 3 years, Average {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_non_current_assets_growth_past_3_years_average > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Total: Total Gross Profit growth achieved
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Non-Current Assets Growth - past 3 years, Total {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_non_current_assets_growth_past_3_years_total > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Has Improved: Has Improved Gross Profit Margin Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Has Total Non-Current Assets Improved - past 3 years = True</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('has_total_non_current_assets_improved_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4"> <strong> Potential Pitfalls or Limitations: </strong></p>
                <ol className="list-decimal list-inside">
                    <li> <strong> Depreciation Factors: </strong> Non-current assets are subject to depreciation, which can complicate their valuation over time and affect financial analysis.</li>
                    <li> <strong> Illiquidity:</strong> These assets are not easily convertible into cash, which could be a disadvantage in times of financial strain.</li>
                    <li> <strong> Investment Risk: </strong> Large amounts of non-current assets may represent sunk costs in technologies or properties that may not yield expected returns, especially if market conditions change.</li>
                </ol>
                <p className="text-sm mb-4">
                    Total Non-Current Assets provide insight into a company's long-term financial strategy and its ability to sustain future growth through substantial investments in its operational foundation.
                </p>
            </div>
        ),
        'total_liabilities': (
            <div id="total-liabilities-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Total Liabilities">
                <p className="text-lg font-semibold mb-4">Total Liabilities</p>
                <p className="text-sm mb-4">
                    Total Liabilities represent the sum of all financial obligations a company owes to outside parties, including both short-term and long-term debts. These liabilities can include accounts payable, loans, bonds, deferred revenue, and other financial commitments due within and beyond the fiscal year.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Total Liabilities:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Total Liabilities = Total Current Liabilities + Total Non-Current Liabilities
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the total liabilities:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Liabilities {'>'} 1B</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_liabilities > 1B')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    CAGR: Compound Annual Growth Rate
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Liabilities Growth - past 3 years, CAGR {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_liabilities_growth_past_3_years_cagr > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Average: Average Gross Profit Margin Growth
                </h3>

                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Liabilities Growth - past 3 years, Average {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_liabilities_growth_past_3_years_average > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Total: Total Gross Profit growth achieved
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Liabilities Growth - past 3 years, Total {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_liabilities_growth_past_3_years_total > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Has Improved: Has Improved Gross Profit Margin Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Has Total Liabilities Improved - past 3 years = True</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('has_total_liabilities_improved_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    <strong>Potential Pitfalls or Limitations:</strong>
                </p>
                <ol className="list-decimal list-inside">
                    <li><strong>Solvency Risk:</strong> High total liabilities can lead to solvency issues if a company's assets do not sufficiently cover its debts, especially during economic downturns.</li>
                    <li><strong>Interest Rate Exposure: </strong> Companies with significant debt are susceptible to interest rate changes, which can affect their cost of capital and profitability.</li>
                    <li><strong>Cash Flow Constraints:</strong> Servicing high levels of debt requires consistent cash flow, which can divert funds from other growth opportunities.</li>
                </ol>
                <p className="text-sm mb-4">
                    Total Liabilities provide key insights into a company's financial health and its approach to leveraging debt, crucial for assessing its financial stability and risk profile.
                </p>
            </div>
        ),
        'total_current_liabilities': (
            <div id="total-current-liabilities-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Total Current Liabilities">
                <p className="text-lg font-semibold mb-4">Total Current Liabilities</p>
                <p className="text-sm mb-4">
                    Total Current Liabilities represent the sum of all short-term financial obligations a company owes to outside parties, including accounts payable, short-term loans, accrued expenses, and other liabilities due within one year. These liabilities are essential for a company's day-to-day operations and liquidity.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Total Current Liabilities:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Total Current Liabilities = Accounts Payable + Short-Term Debt + Accrued Expenses + Other Current Liabilities
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the total current liabilities:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Current Liabilities {'>'} 500M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_current_liabilities > 500M')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                    CAGR: Compound Annual Growth Rate
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Current Liabilities Growth - past 3 years, CAGR {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_current_liabilities_growth_past_3_years_cagr > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Average: Average Total Current Liabilities Growth
                </h3>

                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Current Liabilities Growth - past 3 years, Average {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_current_liabilities_growth_past_3_years_average > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Total: Total Total Current Liabilities growth achieved
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Current Liabilities Growth - past 3 years, Total {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_current_liabilities_growth_past_3_years_total > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Has Improved: Has Improved Total Current Liabilities Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Has Total Current Liabilities Improved - past 3 years = True</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('has_total_current_liabilities_improved_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    <strong>Potential Pitfalls or Limitations:</strong>
                </p>
                <ol className="list-decimal list-inside">
                    <li><strong>Misleading Financial Health Indicators:</strong> High current liabilities relative to current assets can indicate liquidity problems, but this needs to be analyzed in context with the company's ability to generate cash.</li>
                    <li><strong>Seasonal Variations:</strong>Some industries may show spikes in current liabilities at certain times of the year due to seasonal sales cycles or production demands.</li>
                    <li><strong>Operational Risks: </strong> Companies with consistently high current liabilities need careful management to avoid operational disruptions or financial distress.</li>
                </ol>
                <p className="text-sm mb-4">
                    Total Current Liabilities are critical for evaluating a company's short-term financial health and its efficiency in managing the liquidity needed to sustain day-to-day operations.
                </p>
            </div>
        ),
        'total_non_current_liabilities': (
            <div id="total-non-current-liabilities-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Total Non-Current Liabilities">
                <p className="text-lg font-semibold mb-4">Total Non-Current Liabilities</p>
                <p className="text-sm mb-4">
                    Total Non-Current Liabilities represent the sum of all financial obligations a company is expected to settle beyond one fiscal year. These typically include long-term debt, deferred tax liabilities, lease obligations, and other long-term financial commitments.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Total Non-Current Liabilities:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Total Non-Current Liabilities = Long-Term Debt + Deferred Revenue + Other Non-Current Liabilities
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the total non-current liabilities:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Non-Current Liabilities {'>'} 1B</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_non_current_liabilities > 1B')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                    CAGR: Compound Annual Growth Rate
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Non-Current Liabilities Growth - past 3 years, CAGR {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_non_current_liabilities_growth_past_3_years_cagr > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Average: Average Total Non-Current Liabilities Growth
                </h3>

                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Non-Current Liabilities Growth - past 3 years, Average {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_non_current_liabilities_growth_past_3_years_average > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Total: Total Total Non-Current Liabilities growth achieved
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Non-Current Liabilities Growth - past 3 years, Total {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_non_current_liabilities_growth_past_3_years_total > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                    Has Improved: Has Improved Total Non-Current Liabilities Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Has Total Non-Current Liabilities Improved - past 3 years = True</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('has_total_non_current_liabilities_improved_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    <strong>Potential Pitfalls or Limitations:</strong>
                </p>
                <ol className="list-decimal list-inside">
                    <li><strong>Future Financial Burden:</strong> High levels of non-current liabilities can place a significant burden on future cash flows, requiring careful financial management and planning.</li>
                    <li><strong>Interest Rate Risk:</strong> Companies with large amounts of debt are exposed to interest rate risks, which can affect the cost of servicing debt if rates rise.</li>
                    <li><strong>Flexibility Constraints: </strong> Significant long-term liabilities may limit a company's flexibility to respond to market changes or make opportunistic investments.</li>
                </ol>
                <p className="text-sm mb-4">
                    Total Non-Current Liabilities are crucial for assessing a company's long-term financial strategy, its risk profile, and its ability to manage and service long-term debt effectively.
                </p>
            </div>
        ),
        'total_equity': (
            <div id="total-equity-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Total Equity">
                <p className="text-lg font-semibold mb-4">Total Equity</p>
                <p className="text-sm mb-4">
                    Total Equity represents the residual interest in the assets of a company after deducting all its liabilities. It is essentially the net worth of the company, often referred to as shareholder equity or owner's equity, and includes common stock, preferred stock, retained earnings, and accumulated other comprehensive income.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Total Equity:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Total Equity = Total Assets - Total Liabilities
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the total equity:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Equity {'>'} 1B</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_equity > 1B')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    CAGR: Compound Annual Growth Rate
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Equity Growth - past 3 years, CAGR {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_equity_growth_past_3_years_cagr > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Average: Average Total Equity Growth
                </h3>

                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Equity Growth - past 3 years, Average {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_equity_growth_past_3_years_average > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Total: Total Total Equity growth achieved
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Equity Growth - past 3 years, Total {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_equity_growth_past_3_years_total > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Has Improved: Has Improved Total Equity Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Has Total Equity Improved - past 3 years = True</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('has_total_equity_improved_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    <strong>Potential Pitfalls or Limitations:</strong>
                </p>
                <ol className="list-decimal list-inside">
                    <li><strong>Overleveraging Risks:</strong> High levels of equity can lead to overleveraging if not managed effectively, potentially limiting growth or increasing financial risk.</li>
                    <li><strong>Market Volatility:</strong> Equity values can fluctuate with market conditions, affecting shareholder value and financial stability.</li>
                    <li><strong>Capital Allocation:</strong> Companies with low equity may face challenges in raising capital or investing in growth opportunities.</li>
                </ol>
                <p className="text-sm mb-4">
                    Total Equity is a crucial metric for assessing a company's financial health, providing insight into its capital structure and giving stakeholders an idea of the value that would theoretically be returned if all assets were liquidated and all debts repaid.
                </p>
            </div>
        ),
        'gross_profit_margin_ttm': (
            <div id="gross-profit-margin-ttm-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Gross Profit Margin (TTM)">
                <p className="text-lg font-semibold mb-4">Gross Profit Margin (TTM)</p>
                <p className="text-sm mb-4">
                    Gross Profit Margin (TTM) is a financial metric that measures a company's profitability by calculating the percentage of revenue that exceeds the cost of goods sold (COGS). It provides insights into a company's ability to generate profit from its core business operations.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Gross Profit Margin (TTM):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Gross Profit Margin (TTM) = ((Revenue - COGS) / Revenue ) * 100
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the gross profit margin (TTM):
                </p>

                <h3 className="text-sm mb-4 font-bold">
                    TTM: Gross Profit Margin (TTM)
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Gross Profit Margin (TTM) {'>'} 40%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('gross_profit_margin_ttm > 0.40%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    CAGR: Compound Annual Growth Rate
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Gross Profit Margin Growth - past 3 years, CAGR {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('gross_profit_margin_growth_past_3_years_cagr > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                    Average: Average Gross Profit Margin Growth
                </h3>

                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Gross Profit Margin Growth - past 3 years, Average {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('gross_profit_margin_growth_past_3_years_average > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                    Total: Total Gross Profit growth achieved
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Gross Profit Margin Growth - past 3 years, Total {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('gross_profit_margin_growth_past_3_years_total > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                    Has Improved: Has Improved Gross Profit Margin Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Has Gross Profit Margin Growth improved - past 3 years = True</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('has_gross_profit_margin_improved_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                    Has Turned Around: Has Improved Gross Profit Margin Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Has Gross Profit Margin Growth turned around - past 3 years = True</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('has_gross_profit_margin_turned_around_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    The Gross Profit Margin (TTM) is a critical indicator for assessing how effectively a company can convert sales into gross profit, influencing decisions on cost management, pricing strategies, and overall operational efficiency.
                </p>
            </div>
        ),
        'net_profit_margin_ttm': (
            <div id="net-profit-margin-ttm-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Net Profit Margin (TTM)">
                <p className="text-lg font-semibold mb-4">Net Profit Margin (TTM)</p>
                <p className="text-sm mb-4">
                    The Net Profit Margin (TTM), or trailing twelve months net profit margin, measures the percentage of total revenue that remains as profit after all expenses, including cost of goods sold (COGS), operating expenses, interest, taxes, and other deductions, have been subtracted. It is a key indicator of a company's overall financial efficiency and profitability over the last twelve months.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Net Profit Margin (TTM):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Net Profit Margin (TTM) = ( Net profit / Total Revenue ) * 100
                </div>
                <p className="text-sm mb-4">
                    <strong>Interpretation:</strong>
                </p>
                <ol className="list-decimal list-inside">
                    <li><strong>High Net Profit Margin ({'>'}15%):</strong> Indicates strong profitability and efficient cost management, potentially leading to higher shareholder returns and sustainable growth.</li>
                    <li><strong>Moderate Net Profit Margin (5% to 15%):</strong> Indicates reasonable efficiency in managing costs relative to earnings. This range is typical for well-run companies in competitive industries..</li>
                    <li><strong>Low Net Profit Margin ({'<'}5%):</strong> Reflects tight profit conditions, possibly due to high costs, inefficient operations, or intense competitive pressures, which may challenge sustainability and growth prospects..</li>
                </ol>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the net profit margin (TTM):
                </p>
                <h3 className="text-sm mb-4 font-bold">
                    TTM: Total Trailing 12 Months
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Net Profit Margin (TTM) {'>'} 10%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('net_profit_margin_ttm > 10%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    CAGR: Compound Annual Growth Rate
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Net Profit Margin Growth - past 3 years, CAGR {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('net_profit_margin_growth_past_3_years_cagr > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Average: Average Net Profit Margin Growth
                </h3>

                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Net Profit Margin Growth - past 3 years, Average {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('net_profit_margin_growth_past_3_years_average > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                    Total: Total Net Profit Margin growth achieved
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Net Profit Margin Growth - past 3 years, Total {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('net_profit_margin_growth_past_3_years_total > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                    Has Improved: Has Improved EPS Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Has Net Profit Margin Improved - past 3 years = True</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('has_net_profit_margin_improved_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                    Has Turned Around: Has Improved Net Profit Margin Growth
                </h3>

                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Has Net Profit Margin growth turned around - past 3 years  = True</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('has_net_profit_margin_turned_around_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    Understanding the Net Profit Margin (TTM) is crucial for assessing a company's overall financial performance, providing insights into its profitability and operational efficiency in generating earnings from its revenues.
                </p>
            </div>
        ),
        'operating_profit_margin_ttm': (
            <div id='operating-profit-margin-ttm-info-section' className="education-info-section mb-5 text-gray-700" data-suggest-name="Operating Profit Margin (TTM)">
                <p className="text-lg font-semibold mb-4">Operating Profit Margin (TTM)</p>
                <p className="text-sm mb-4">
                    The Operating Profit Margin (TTM) measures the percentage of revenue remaining after all operating expenses have been deducted from total sales over the trailing twelve months. This metric indicates the efficiency and profitability of a company's core business activities, excluding interest and tax expenses.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Operating Profit Margin (TTM):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Operating Profit Margin (TTM) = (Operating Profit / Total Revenue) * 100
                </div>
                <p className="text-sm mb-4">
                    <strong>Interpretation:</strong>
                </p>
                <ol className="list-decimal list-inside">
                    <li><strong>High Operating Profit Margin({'>'}20%):</strong> Indicates strong operational efficiency and profitability, potentially leading to higher shareholder returns and sustainable growth.</li>
                    <li><strong>Moderate Operating Profit Margin(10-20%):</strong> Suggests a balanced approach to managing operating costs and generating profit, supporting sustainable operations and financial performance.</li>
                    <li><strong>Low Operating Profit Margin({'<'}10%):</strong> Reflects challenges in cost management or operational efficiency, which may require adjustments to improve profitability and competitiveness.</li>
                </ol>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the operating profit margin (TTM):
                </p>
                <h3 className="text-sm mb-4 font-bold">
                    TTM: Operating Profit Margin (TTM)
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Operating Profit Margin (TTM) {'>'} 20%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('operating_profit_margin_ttm > 20%')}
                    >{filterButtonPlaceholder}</Button>
                </div>


                <p className="text-sm mb-4">
                    <strong>Potential Pitfalls or Limitations:</strong>
                </p>
                <ol className="list-decimal list-inside">
                    <li><strong>Exclusion of Financial Costs:</strong>  The metric does not account for interest or taxes, which can significantly affect net profitability.</li>
                    <li><strong>Seasonal Variability:</strong> Revenue and expenses in some sectors fluctuate seasonally, potentially distorting margin analysis in shorter financial periods.</li>
                    <li><strong>Industry-Specific Norms:</strong> Operating margins vary greatly across industries, so benchmarks should be industry-specific to avoid misleading comparisons.</li>
                </ol>

                <h3 className="text-sm mb-4 font-bold">
                    CAGR: Compound Annual Growth Rate
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Operating Profit Margin Growth - past 5 years, CAGR {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('operating_profit_margin_growth_past_3_years_cagr > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Average: Average Operating Profit Margin Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Operating Profit Margin Growth - past 3 years, Average {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('operating_profit_margin_growth_past_3_years_average > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Total: Total Operating Profit Margin growth achieved
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Operating Profit Margin Growth - past 3 years, Total {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('operating_profit_margin_growth_past_3_years_total > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Has Improved: Has Improved Operating Profit Margin Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Has Operating Profit Margin Improved - past 3 years = True</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('has_operating_profit_margin_improved_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Has Turned Around: Has Improved Operating Profit Margin Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Has Operating Profit Margin growth turned around - past 3 years = True</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('has_operating_profit_margin_turned_around_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    The Operating Profit Margin (TTM) is a key indicator of a company's operational effectiveness and its ability to generate profit from its core business, underlining the importance of contextual and comparative analysis within specific industries.
                </p>
            </div>
        ),
        'price_to_earnings_growth_ratio_ttm': (
            <div id="price-to-earnings-growth-ratio-ttm-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Price to Earnings Growth Ratio (TTM)">
                <p className="text-lg font-semibold mb-4">Price to Earnings Growth Ratio (TTM)</p>
                <p className="text-sm mb-4">
                    The Price to Earnings Growth Ratio (PEG Ratio) is a valuation metric that relates a company's stock price to its earnings per share (EPS) growth rate over the trailing twelve months (TTM). The PEG ratio adjusts the traditional price-to-earnings (P/E) ratio by the company's earnings growth rate, providing a more complete picture of whether a stock is undervalued or overvalued considering its expected growth.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Price to Earnings Growth Ratio (TTM):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Price to Earnings Growth Ratio (TTM) = P/E Ratio / Earnings Growth Rate
                </div>
                <p className="text-sm mb-4">
                    <strong>Interpretation:</strong>
                </p>
                <ol className="list-decimal list-inside">
                    <li><strong>High PEG Ratio {'>'} 1.5:</strong> May indicate that the stock is overvalued relative to its earnings growth rate, suggesting that the market has potentially high expectations for future growth which may not be justifiable.</li>
                    <li><strong>Moderate PEG Ratio (1 to 1.5):</strong>Suggests a fair valuation in relation to the company's earnings growth rate, often signaling that the stock is priced appropriately given its growth prospects.</li>
                    <li><strong>Low PEG Ratio {'<'} 1:</strong> Implies that the stock may be undervalued relative to its earnings growth, providing a potentially attractive investment opportunity if the market has underestimated the company's growth potential.</li>
                </ol>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the price to earnings growth ratio (TTM):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>PEG Ratio {'<'} 1</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('price_to_earnings_growth_ratio_ttm < 1')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>PEG Ratio {'>'} 2</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('price_to_earnings_growth_ratio_ttm > 2')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>PEG Ratio {'='} 1</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('price_to_earnings_growth_ratio_ttm = 1')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    The PEG Ratio is particularly useful for investors looking to evaluate a stock's price not just in isolation, but in the context of the company's earnings growth, providing a more nuanced approach than the P/E ratio alone. It helps in identifying potentially over or under-valued stocks in the context of their expected future growth.
                </p>
            </div>
        ),
        'trailing_pe': (
            <div id="trailing-pe-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Trailing P/E">
                <p className="text-lg font-semibold mb-4">Trailing P/E</p>
                <p className="text-sm mb-4">
                    The Trailing Price-to-Earnings (Trailing P/E) Ratio is a valuation metric that compares a company's current stock price to its earnings per share (EPS) over the past twelve months. This ratio provides an indication of how much investors are willing to pay for each dollar of a company's earnings, based on its historical performance.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Trailing P/E:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Trailing P/E = Current Stock Price / Earnings Per Share (TTM)
                </div>
                <p className="text-sm mb-4">
                    <strong>Interpretation:</strong>
                </p>
                <ol className="list-decimal list-inside">
                    <li><strong>High Trailing P/E {'>'} 20:</strong>Suggests that investors expect higher earnings growth in the future or that the stock is potentially overvalued, common in high-growth industries such as technology.</li>
                    <li><strong>Moderate Trailing P/E (10 to 20):</strong> Indicates a reasonable valuation that aligns more closely with the broader market average, typical for established companies with steady growth prospects.</li>
                    <li><strong>Low Trailing P/E {'<'} 10:</strong>Implies that the stock may be undervalued or that the company is experiencing issues that could dampen investor expectations, often seen in more cyclical or struggling industries.</li>
                </ol>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the trailing P/E:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Trailing P/E {'<'} 10</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('trailing_pe < 10')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Trailing P/E {'>'} 20</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('trailing_pe > 20')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Trailing P/E {'<='} 15</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('trailing_pe <= 15')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    The Trailing P/E ratio is a widely used metric for evaluating a company's stock price relative to its earnings, helping investors assess the valuation and growth potential of a stock based on its historical earnings performance.The Trailing P/E Ratio is widely used by investors to assess the relative value of a stock in light of its earnings track record, helping to gauge whether a stock is overpriced, underpriced, or fairly valued based on historical earnings data.
                </p>
            </div>
        ),
        'forward_pe': (
            <div id="forward-pe-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Forward P/E">
                <p className="text-lg font-semibold mb-4">Forward P/E</p>
                <p className="text-sm mb-4">
                    The Forward Price-to-Earnings (Forward P/E) Ratio is a valuation metric that compares a company's current stock price to its expected earnings per share (EPS) over the next twelve months. This ratio provides an indication of how much investors are willing to pay for each dollar of a company's expected future earnings.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Forward P/E:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Forward P/E = Current Stock Price / Expected Earnings Per Share (Next 12 Months)
                </div>
                <p className="text-sm mb-4">
                    <strong>Interpretation:</strong>
                </p>
                <ol className="list-decimal list-inside">
                    <li><strong>High Forward P/E {'>'} 20:</strong>  Indicates that investors are willing to pay a premium for the expected growth in earnings, typical in industries with high growth potential like technology or renewable energy.</li>
                    <li><strong>Moderate Forward P/E (10 to 20):</strong> Suggests a more balanced market expectation regarding future earnings, common in sectors with steady growth such as consumer products or financial services.</li>
                    <li><strong>Low Forward P/E {'<'} 10:</strong> Implies skepticism about future earnings growth or potential undervaluation, often seen in more mature or currently unfavored industries like utilities or basic materials.</li>
                </ol>
                <p>
                    Below are some sample queries related to the forward P/E:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Forward P/E {'<'} 10</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('forward_pe < 10')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Forward P/E {'>'} 20</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('forward_pe > 20')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Forward P/E {'<='} 15</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('forward_pe <= 15')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4"><strong>Potential Pitfalls or Limitations:</strong></p>
                <p className="text-sm mb-4">The Forward P/E Ratio's accuracy heavily depends on earnings forecasts, which may be inaccurate, and it does not account for broader financial health or sudden market changes, potentially misleading investors about a company's true valuation prospects.</p>
                <p className="text-sm mb-4">
                    The Forward P/E Ratio is particularly useful for investors who are looking to gauge the market's expectations of a company's future profitability, offering a forward-looking complement to the traditionally backward-looking trailing P/E ratio.
                </p>
            </div>
        ),
        'revenue_per_share_ttm': (
            <div id="revenue-per-share-ttm-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Revenue Per Share (TTM)">
                <p className="text-lg font-semibold mb-4">Revenue Per Share (TTM)</p>
                <p className="text-sm mb-4">
                    Revenue Per Share (TTM) is a financial metric that calculates the total revenue generated by a company over the trailing twelve months (TTM) divided by the total number of outstanding shares. This ratio provides insights into the company's revenue-generating efficiency on a per-share basis, helping investors assess the company's revenue performance relative to its market capitalization.
                </p>
                <p>
                    Formula for calculating Revenue Per Share (TTM):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Revenue Per Share (TTM) = Total Revenue (TTM) / Average Outstanding Shares (TTM)
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the revenue per share (TTM):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Revenue Per Share (TTM) {'>'} 50</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('revenue_per_share_ttm > 50')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Revenue Per Share (TTM) {'<='} 30</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('revenue_per_share_ttm <= 30')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Revenue Per Share (TTM) {'>='} 40</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('revenue_per_share_ttm >= 40')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4"><strong>Typical Applications:</strong></p>
                <p className="text-sm mb-4"> Investors use this metric to compare the revenue efficiency of companies within the same industry or sector, adjusting for differences in the number of shares outstanding. It's particularly useful in assessing companies with varying share quantities or for evaluating the impact of share buybacks on revenue generation.</p>
            </div>
        ),
        'enterprise_value_ttm': (
            <div id="enterprise-value-ttm-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Enterprise Value (TTM)">
                <p className="text-lg font-semibold mb-4">Enterprise Value (TTM)</p>
                <p className="text-sm mb-4">
                    Enterprise Value (EV) is a comprehensive measure of a company's total value, calculated as the market capitalization plus debt, minority interest, and preferred shares, minus total cash and cash equivalents. This metric provides a more complete picture than market capitalization alone, as it includes debt and cash levels, offering insight into what it would cost to purchase the entire business outright.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Enterprise Value (TTM):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Enterprise Value (TTM) = Market Capitalization + Total Debt Preferred Stock + Minority Interest - Cash and Cash Equivalents
                </div>
                <p className="text-sm mb-4"><strong>Why It Matters:</strong></p>
                <p className="text-sm mb-4"> Enterprise Value is crucial for investors because it provides a valuation metric that takes into account a company's entire economic substance. It is especially useful in comparing companies with different capital structures, as it includes debt and cash in the evaluation.</p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the enterprise value (TTM):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Enterprise Value (TTM) {'>'} 10B</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('enterprise_value_ttm > 10B')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Enterprise Value (TTM) {'<='} 5B</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('enterprise_value_ttm <= 5B')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Enterprise Value (TTM) {'>='} 15B</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('enterprise_value_ttm >= 15B')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4"><strong>Typical Applications:</strong></p>
                <p className="text-sm mb-4">EV allows for more equitable comparisons between companies with different financing structures, including those heavily reliant on debt or those holding large cash reserves.</p>
            </div>
        ),
        'book_value_per_share_ttm': (
            <div id="book-value-per-share-ttm-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Book Value Per Share (TTM)">
                <p className="text-lg font-semibold mb-4">Book Value Per Share (TTM)</p>
                <p className="text-sm mb-4">
                    Book Value Per Share (TTM) calculates the per-share value of a company's equity after subtracting any preferred equity. It represents what shareholders would theoretically receive per share if the company were liquidated at its book value
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Book Value Per Share (TTM):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Book Value Per Share (TTM) = Total Shareholders' Equity (TTM)−Preferred Equity / Average Outstanding Shares (TTM)
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the book value per share (TTM):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Book Value Per Share (TTM) {'>'} 20</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('book_value_per_share_ttm > 20')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Book Value Per Share (TTM) {'<='} 10</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('book_value_per_share_ttm <= 10')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Book Value Per Share (TTM) {'>='} 15</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('book_value_per_share_ttm >= 15')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    Book Value Per Share (TTM) is a key metric for investors and analysts to assess a company's financial health and intrinsic value, providing insights into the company's net worth and potential for growth or investment.
                </p>
            </div>
        ),
        'ebitda': (
            <div id="ebitda-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="EBITDA">
                <p className="text-lg font-semibold mb-4">EBITDA</p>
                <p className="text-sm mb-4">
                    EBITDA is a financial metric that calculates a company's earnings before the deduction of interest expenses, taxes, depreciation, and amortization. This measure provides insight into the operational profitability of a company by focusing solely on business activities without the effects of financing and accounting decisions.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating EBITDA:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    EBITDA = Net Income + Interest + Taxes + Depreciation + Amortization
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the EBITDA:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>EBITDA {'>'} 100M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('ebitda > 100M')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>EBITDA {'<='} 50M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('ebitda <= 50M')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>EBITDA {'>='} 75M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('ebitda >= 75M')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    EBITDA helps provide a cleaner view of operational profitability and efficiency by removing the noise created by non-operational factors. However, it should be used in conjunction with other financial metrics to gain a comprehensive understanding of a company's financial health and operational performance.
                </p>
            </div>
        ),
        'return_on_assets_ttm': (
            <div id="return-on-assets-ttm-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Return on Assets (TTM)">
                <p className="text-lg font-semibold mb-4">Return on Assets (TTM)</p>
                <p className="text-sm mb-4">
                    Return on Assets (TTM), or ROA, is a financial metric that measures a company's profitability relative to its total assets over the trailing twelve months. It indicates how efficiently a company is using its assets to generate earnings.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Return on Assets (TTM):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Return on Assets (TTM) = Net Income / Average Total Assets
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the return on assets (TTM):
                </p>
                <h3 className="text-sm mb-4 font-bold">
                    TTM: Return on Assets (TTM)
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Return on Assets (TTM) {'>'} 10%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('return_on_assets_ttm > 10%')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                    CAGR: Compound Annual Growth Rate
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>ROA Growth - past 3 years, CAGR {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('roa_growth_past_3_years_cagr > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Average: Average Gross ROA Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>ROA Growth - past 3 years, Average {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('roa_growth_past_3_years_average > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Total: Total ROA growth achieved
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>ROA Growth - past 3 years, Total {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('roa_growth_past_3_years_total > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Has Improved: Has Improved ROA Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Has ROA Improved - past 3 years = True</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('has_roa_improved_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    ROA provides a snapshot of management effectiveness in using assets to generate earnings but should be analyzed in the context of the industry and the company's broader financial environment to make informed investment decisions.
                </p>
            </div>
        ),
        'return_on_equity_ttm': (
            <div id="return-on-equity-ttm-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Return on Equity (TTM)">
                <p className="text-lg font-semibold mb-4">Return on Equity (TTM)</p>
                <p className="text-sm mb-4">
                    Return on Equity (TTM), or ROE, measures a company's ability to generate profits from its shareholders' equity over the trailing twelve months. This metric highlights how effectively management is using the equity invested by the shareholders to produce net income.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Return on Equity (TTM):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Return on Equity (TTM) = Net Income / Average Shareholders' Equity
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the return on equity (TTM):
                </p>
                <h3 className="text-sm mb-4 font-bold">
                    TTM: Return on Equity (TTM)
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Return on Equity (TTM) {'>'} 15%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('return_on_equity_ttm > 15%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    CAGR: Compound Annual Growth Rate
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>ROE Growth - past 3 years, CAGR {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('roe_growth_past_3_years_cagr > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Average: Average ROE Growth
                </h3>

                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>ROE Growth - past 3 years, Average {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('roe_growth_past_3_years_average > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Total: Total ROE growth achieved
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>ROE Growth - past 3 years, Total {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('roe_growth_past_3_years_total > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Has Improved: Has Improved ROE Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Has ROE Improved - past 3 years = True</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('has_roe_improved_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    ROE is a valuable metric for evaluating the profitability and efficiency of a company in using its shareholders' equity but should be used in conjunction with other financial analysis tools to get a comprehensive view of a company's financial health and operational performance.
                </p>
            </div>
        ),
        'return_on_investment_ttm': (
            <div id="return-on-investment-ttm-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Return on Investment (TTM)">
                <p className="text-lg font-semibold mb-4">Return on Investment (TTM)</p>
                <p className="text-sm mb-4">
                    Return on Investment (TTM), or ROI, measures a company's ability to generate profits from its shareholders' equity over the trailing twelve months. This metric highlights how effectively management is using the equity invested by the shareholders to produce net income.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Return on Investment (TTM):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Return on Investment (TTM) = Net Income / Average Shareholders' Equity
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the return on equity (TTM):
                </p>
                <h3 className="text-sm mb-4 font-bold">
                    TTM: Return on Investment (TTM)
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Return on Investment (ROI) {'>'} 15%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('return_on_investment_ttm > 15%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    CAGR: Compound Annual Growth Rate
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>ROI Growth - past 3 years, CAGR {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('roi_growth_past_3_years_cagr > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Average: Average ROI Growth
                </h3>

                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>ROI Growth - past 3 years, Average {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('roi_growth_past_3_years_average > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Total: Total ROI growth achieved
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>ROI Growth - past 3 years, Total {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('roi_growth_past_3_years_total > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Has Improved: Has Improved ROI Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Has ROI Improved - past 3 years = True</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('has_roi_improved_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    ROE is a valuable metric for evaluating the profitability and efficiency of a company in using its shareholders' equity but should be used in conjunction with other financial analysis tools to get a comprehensive view of a company's financial health and operational performance.
                </p>
            </div>
        ),
        'short_percent': (
            <div id="short-percent-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Short Percent">
                <p className="text-lg font-semibold mb-4">Short Percent</p>
                <p className="text-sm mb-4">
                    Short Percent of Float is a financial metric that indicates the proportion of a company's publicly traded shares that are currently sold short compared to the total number of shares available for public trading (the float). It provides insight into investor sentiment and market speculation regarding a company's future stock performance.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the short percent:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Short Percent {'>'} 10%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('short_percent > 10%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Short Percent {'<='} 5%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('short_percent <= 5%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Short Percent {'>='} 7%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('short_percent >= 7%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    Understanding the Short Percent of Float helps investors gauge the level of pessimism or speculative pressure on a stock, which can be a critical factor in decision-making for both short-term trading and long-term investment strategies.
                </p>
            </div>
        ),
        'analyst_strong_buy_percentage': (
            <div id="analyst-strong-buy-percentage-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Analyst Strong Buy Percentage">
                <p className="text-lg font-semibold mb-4">Analyst Strong Buy Percentage</p>
                <p className="text-sm mb-4">
                    Analyst Strong Buy Percentage measures the proportion of analysts recommending a 'Strong Buy' for a stock relative to the total number of analyst recommendations available. This metric indicates the level of bullish sentiment among financial analysts regarding the future performance of a stock.
                </p>
                <p className="text-sm mb-4">
                    Formula:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Analyst Strong Buy Percentage = (Number of Analyst Strong Buy Recommendations / Total Number of Analyst Recommendations) * 100
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the analyst strong buy percentage:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Analyst Strong Buy Percentage {'>'} 70%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('analyst_strong_buy_percentage > 70%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Analyst Strong Buy Percentage {'<='} 50%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('analyst_strong_buy_percentage <= 50%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Analyst Strong Buy Percentage {'>='} 60%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('analyst_strong_buy_percentage >= 60%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    The Analyst Strong Buy Percentage helps investors gauge expert opinions and market confidence in a stock, serving as one of many tools in making informed investment decisions. However, it's important for investors to use this information as part of a broader investment analysis process that includes financial data, market trends, and their own investment criteria.
                </p>
            </div>
        ),
        'analyst_buy_percentage': (
            <div id="analyst-buy-percentage-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Analyst Buy Percentage">
                <p className="text-lg font-semibold mb-4">Analyst Buy Percentage</p>
                <p className="text-sm mb-4">
                    Analyst Buy Percentage indicates the proportion of analysts who have issued a 'Buy' recommendation for a stock relative to the total number of analyst recommendations available. This metric reflects a generally positive sentiment among financial analysts about the stock's future performance but typically with less conviction than a 'Strong Buy' recommendation.
                </p>
                <p className="text-sm mb-4">
                    Formula:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Analyst Buy Percentage = (Number of Analyst Buy Recommendations / Total Number of Analyst Recommendations) * 100
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the analyst buy percentage:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Analyst Buy Percentage {'>'} 60%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('analyst_buy_percentage > 60%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Analyst Buy Percentage {'<='} 40%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('analyst_buy_percentage <= 40%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Analyst Buy Percentage {'>='} 50%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('analyst_buy_percentage >= 50%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    Analyst Buy Percentage offers a snapshot of professional sentiment toward a stock and can be a useful tool for investors when combined with comprehensive analysis and personal investment strategy considerations.
                </p>
            </div>
        ),
        'analyst_hold_percentage': (
            <div id="analyst-hold-percentage-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Analyst Hold Percentage">
                <p className="text-lg font-semibold mb-4">Analyst Hold Percentage</p>
                <p className="text-sm mb-4">
                    Analyst Hold Percentage measures the proportion of financial analysts who recommend maintaining current holdings of a stock (neither buying more nor selling off), relative to the total number of analyst recommendations available. This metric reflects a neutral sentiment, suggesting that analysts believe the stock will perform in line with market expectations without significant upside or downside.
                </p>
                <p className="text-sm mb-4">
                    Formula:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Analyst Hold Percentage = (Number of Analyst Hold Recommendations / Total Number of Analyst Recommendations) * 100
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the analyst hold percentage:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Analyst Hold Percentage {'>'} 40%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('analyst_hold_percentage > 40%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Analyst Hold Percentage {'<='} 30%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('analyst_hold_percentage <= 30%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Analyst Hold Percentage {'>='} 35%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('analyst_hold_percentage >= 35%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    The Analyst Hold Percentage offers a measure of consensus about the expected stability of a stock's price, useful in assessing whether to maintain existing positions or seek additional analysis for a potential strategic shift.
                </p>
            </div>
        ),
        'analyst_sell_percentage': (
            <div id='analyst-sell-percentage-info-section' className="education-info-section mb-5 text-gray-700" data-suggest-name="Analyst Sell Percentage">
                <p className="text-lg font-semibold mb-4">Analyst Sell Percentage</p>
                <p className="text-sm mb-4">
                    Analyst Sell Percentage measures the proportion of financial analysts who recommend selling a stock relative to the total number of analyst recommendations. This metric indicates a negative sentiment among analysts regarding the stock's future performance and suggests that the stock may underperform relative to market expectations or its sector.
                </p>
                <p className="text-sm mb-4">
                    Formula:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Analyst Sell Percentage = (Number of Analyst Sell Recommendations / Total Number of Analyst Recommendations) * 100
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the analyst sell percentage:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Analyst Sell Percentage {'>'} 20%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('analyst_sell_percentage > 20%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Analyst Sell Percentage {'<='} 10%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('analyst_sell_percentage <= 10%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Analyst Sell Percentage {'>='} 15%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('analyst_sell_percentage >= 15%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
            </div>
        ),
        'analyst_strong_sell_percentage': (
            <div id="analyst-strong-sell-percentage-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Analyst Strong Sell Percentage">
                <p className="text-lg font-semibold mb-4">Analyst Strong Sell Percentage</p>
                <p className="text-sm mb-4">
                    Analyst Strong Sell Percentage indicates the proportion of financial analysts who give a stock the most negative recommendation possible, suggesting a strong conviction that the stock will perform poorly in the future compared to market expectations or its peers.
                </p>
                <p className="text-sm mb-4">
                    Formula:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Analyst Strong Sell Percentage = (Number of Analyst Strong Sell Recommendations / Total Number of Analyst Recommendations) * 100
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the analyst strong sell percentage:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Analyst Strong Sell Percentage {'>'} 10%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('analyst_strong_sell_percentage > 10%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Analyst Strong Sell Percentage {'<='} 5%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('analyst_strong_sell_percentage <= 5%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Analyst Strong Sell Percentage {'>='} 8%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('analyst_strong_sell_percentage >= 8%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    The Analyst Strong Sell Percentage can provide critical insights into potential risks associated with a particular stock. Investors should use this data cautiously, complementing it with comprehensive research and considering the broader market context to make well-informed investment decisions.
                </p>
            </div>
        ),
        'insiders_shares_hold_percent': (
            <div id="insiders-shares-hold-percent-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Insiders Shares Hold Percent">
                <p className="text-lg font-semibold mb-4">Insiders Shares Hold Percent</p>
                <p className="text-sm mb-4">
                    Insiders Shares Hold Percentage refers to the proportion of a company's shares that are held by insiders, such as executives, directors, and other key employees, relative to the total number of shares outstanding. This metric indicates how much company stock is owned by those who are closest to the company's operations and strategic planning.
                </p>
                <p className="text-sm mb-4">
                    Formula:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Insiders Shares Hold Percentage = (Number of Insider Shares Held / Total Shares Outstanding) * 100
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the insiders shares hold percent:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Insiders Shares Hold Percent {'>'} 20%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('insiders_shares_hold_percent > 20%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Insiders Shares Hold Percent {'<='} 10%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('insiders_shares_hold_percent <= 10%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Insiders Shares Hold Percent {'>='} 15%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('insiders_shares_hold_percent >= 15%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    Insiders Shares Hold Percent is a valuable metric for investors to assess the level of confidence and commitment that company insiders have in the business. It can be used as a positive signal when evaluating investment opportunities and aligning investment decisions with insiders' interests.
                </p>
            </div>
        ),
        'institutions_shares_hold_percent': (
            <div id="institutions-shares-hold-percent-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Institutions Shares Hold Percent">
                <p className="text-lg font-semibold mb-4">Institutions Shares Hold Percent</p>
                <p className="text-sm mb-4">
                    Institutions Shares Hold Percentage measures the proportion of a company's shares that are held by institutional investors, such as mutual funds, pension funds, and insurance companies, relative to the total shares outstanding. This metric highlights the level of institutional ownership, indicating the confidence and involvement of large, professional investors in the company.
                </p>
                <p className="text-sm mb-4">
                    Formula:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Institutions Shares Hold Percentage = (Number of Institutional Shares Held / Total Shares Outstanding) * 100
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the institutions shares hold percent:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Institutions Shares Hold Percent {'>'} 30%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('institutions_shares_hold_percent > 30%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Institutions Shares Hold Percent {'<='} 20%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('institutions_shares_hold_percent <= 20%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Institutions Shares Hold Percent {'>='} 25%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('institutions_shares_hold_percent >= 25%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    Institutions Shares Hold Percent is a key metric for investors to gauge the level of professional investor interest and confidence in a stock. It can provide valuable insights for making investment decisions and aligning investment strategies with institutional trends.
                </p>
            </div>
        ),
        'industry': (
            <div id="industry-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Industry">
                <p className="text-lg font-semibold mb-4">Industry</p>
                <p className="text-sm mb-4">
                    Industry refers to the specific sector or field in which a company operates or conducts its business activities. It categorizes companies based on the type of products or services they provide and the markets they serve.
                </p>
                <p className="text-sm mb-4">
                    The industry classification system organizes companies into different sectors, such as technology, healthcare, finance, manufacturing, and many others. Each industry sector has its own unique characteristics, challenges, and opportunities.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the industry:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Industry = Furnishings</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('industry = furnishings')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Industry = Medical Distribution</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('industry = medical_distribution')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Industry = Insurance</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('industry = insurance')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    Understanding the industry in which a company operates is essential for investors, analysts, and stakeholders to assess its competitive landscape, growth potential, and overall market dynamics.
                </p>
            </div>
        ),
        'sector': (
            <div id="sector-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Sector">
                <p className="text-lg font-semibold mb-4">Sector</p>
                <p className="text-sm mb-4">
                    Sector refers to the broader category or industry group to which a company belongs based on its primary business activities and focus. It is used to classify companies into distinct segments according to the nature of their operations and the markets they serve.
                </p>
                <p className="text-sm mb-4">
                    Sectors are typically defined based on the Global Industry Classification Standard (GICS), which categorizes companies into different sectors and sub-sectors, such as technology, healthcare, financial services, consumer goods, and more.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the sector:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Sector = Technology</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('sector = Technology')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Sector = Healthcare</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('sector = Healthcare')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Sector = Financial Services</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('sector = financial_services')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    Understanding the sector in which a company operates is crucial for investors, analysts, and stakeholders to evaluate its performance, growth prospects, and competitive landscape within the broader industry.
                </p>
            </div>
        ),
        'eps_ttm': (
            <div id="eps-info-section" className="education-info-section mb-5 text-gray-700 mt-5" data-suggest-name="EPS (Earnings Per Share)">
                <p className="text-lg font-semibold mb-4">EPS (Earnings Per Share)</p>
                <p className="text-sm mb-4">
                    EPS stands for "Earnings Per Share," and it is a key financial metric used to measure a company's profitability. EPS is calculated by dividing a company's net income (or profit) by the total number of outstanding shares of its common stock. The formula for calculating EPS is:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    EPS = Net Income / Number of Outstanding Shares
                </div>
                <p className="text-sm mb-4">
                    Below are the sample queries for market cap:
                </p>
                <h3 className="text-sm mb-4 font-bold">
                    TTM: Total Trailing 12 Months
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span> EPS (TTM) {'>'} 1</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('eps_ttm > 1')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    CAGR: Compound Annual Growth Rate
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>EPS Growth - past 3 years, CAGR {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('eps_growth_past_3_years_cagr > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Average: Average EPS Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>EPS Growth - past 3 years, Average {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('eps_growth_past_3_years_average > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                    Total: Total EPS growth achieved
                </h3>

                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>EPS Growth - past 3 years, Total {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('eps_growth_past_3_years_total > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Has Positive: Has Positive EPS Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Has Postive EPS - past 3 years = True</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('has_positive_eps_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Has Turned Around: Has Improved EPS Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Has EPS Growth turned around - past 3 years = True</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('has_eps_turned_around_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Has Improved: Has Improved EPS Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Has EPS Improved - past 3 years = True</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('has_eps_improved_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Growth: Projected growth rate of earnings per share
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>EPS Growth Estimate (next 3 years) {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('eps_growth_estimate_next_3_years > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <p className="text-sm mb-4">
                    In other words, EPS represents the portion of a company's profit allocated to each outstanding share of its common stock. It is expressed as a monetary value (e.g., dollars or cents) per share. Investors and analysts often consider EPS when evaluating a company's financial performance and profitability.
                </p>
            </div>
        ),
        'institutional_holders': (
            <div id="institutional-holders-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Institutional Holders">
                <p className="text-lg font-semibold mb-4">Institutional Holders</p>
                <p className="text-sm mb-4">
                    Institutional Holders refer to large financial institutions, such as mutual funds, pension funds, insurance companies, and investment firms, that hold significant amounts of a company's stock. These institutional investors manage large pools of capital and make substantial investments in publicly traded companies.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the institutional holders:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Institutional Holders {'='} Blackrock</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('institutional_holders = Blackrock')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Institutional Holders {'='} Bank of America Corp</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('institutional_holders = bank_of_america_corp')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Institutional Holders {'='} Goldman Sachs Group Inc</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('institutional_holders = goldman_sachs_group_inc')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    Institutional Holders data is a valuable resource for investors to assess the level of professional investor interest and confidence in a stock. It can provide critical insights for making investment decisions and aligning investment strategies with institutional trends.
                </p>
            </div>
        ),
        'price_to_earnings_ratio': (
            <div id="price-to-earnings-ratio-ttm-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Price to Earnings Ratio (TTM)">
                <p className="text-lg font-semibold mb-4">Price to Earnings Ratio (TTM)</p>
                <p className="text-sm mb-4">
                    The Price to Earnings Ratio (TTM), or P/E Ratio, measures the current share price relative to the earnings per share (EPS) over the trailing twelve months (TTM). This ratio is a widely used metric to assess the valuation of a company, indicating how much investors are willing to pay per dollar of earnings.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Price to Earnings Ratio (TTM):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Price to Earnings Ratio (TTM) = Current Share Price / Earnings Per Share (TTM)
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the price to earnings ratio (TTM):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Price to Earnings Ratio (TTM) {'>'} 20</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('price_to_earnings_ratio > 20')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Price to Earnings Ratio (TTM) {'<='} 15</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('price_to_earnings_ratio <= 15')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Price to Earnings Ratio (TTM) {'>='} 18</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('price_to_earnings_ratio >= 18')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    The Price to Earnings Ratio (TTM) is a valuable tool for investors to evaluate a company's stock price relative to its earnings performance. It is essential to consider the P/E Ratio in conjunction with other financial metrics and market factors to make well-informed investment decisions.
                </p>
            </div>
        ),
        'avg_revenue_growth_6q': (
            <div id="avg-revenue-growth-6q-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Average Revenue Growth (6Q)">
                <p className="text-lg font-semibold mb-4">Average Revenue Growth (6Q)</p>
                <p className="text-sm mb-4">
                    Average Revenue Growth Over Last 6 Quarters is a financial metric that measures the average quarter-over-quarter growth rate of a company's revenue over the most recent six-quarter period. This metric helps to smooth out fluctuations in revenue growth from one quarter to the next, providing a more consistent view of the company's growth trajectory.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Average Revenue Growth (6Q):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Average Revenue Growth (6Q) = ∑(Quarterly Revenue Growth Rates Over Last 6 Quarters) / 6
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the average revenue growth (6Q):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Revenue Growth (6Q) {'>'} 10%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_revenue_growth_6q > 10%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Revenue Growth (6Q) {'<='} 5%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_revenue_growth_6q <= 5%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Revenue Growth (6Q) {'>='} 8%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_revenue_growth_6q >= 8%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    By tracking Average Revenue Growth Over Last 6 Quarters, investors can gain insights into a company's growth momentum and operational effectiveness, aiding in the evaluation of the company's potential for future growth and profitability.
                </p>
            </div>
        ),
        'avg_revenue_growth_4q': (
            <div id="avg-revenue-growth-4q-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Average Revenue Growth (4Q)">
                <p className="text-lg font-semibold mb-4">Average Revenue Growth (4Q)</p>
                <p className="text-sm mb-4">
                    Average Revenue Growth Over Last 4 Quarters is a financial metric that measures the average quarter-over-quarter growth rate of a company's revenue over the most recent four-quarter period. This metric helps to smooth out fluctuations in revenue growth from one quarter to the next, providing a more consistent view of the company's growth trajectory.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Average Revenue Growth (4Q):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Average Revenue Growth (4Q) = ∑(Quarterly Revenue Growth Rates Over Last 4 Quarters) / 4
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the average revenue growth (4Q):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Revenue Growth (4Q) {'>'} 15%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_revenue_growth_4q > 15%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Revenue Growth (4Q) {'<='} 8%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_revenue_growth_4q <= 8%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Revenue Growth (4Q) {'>='} 10%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_revenue_growth_4q >= 10%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    By tracking Average Revenue Growth Over Last 4 Quarters, investors can gain insights into a company's growth momentum and operational effectiveness, aiding in the evaluation of the company's potential for future growth and profitability.
                </p>
            </div>
        ),
        'avg_revenue_growth_1y': (
            <div id="avg-revenue-growth-1y-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Average Revenue Growth (1Y)">
                <p className="text-lg font-semibold mb-4">Average Revenue Growth (1Y)</p>
                <p className="text-sm mb-4">
                    Average Revenue Growth Over Last 1 Year is a financial metric that measures the average year-over-year growth rate of a company's revenue over the most recent twelve-month period. This metric helps to smooth out fluctuations in revenue growth from one quarter to the next, providing a more consistent view of the company's growth trajectory.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Average Revenue Growth (1Y):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Average Revenue Growth (1Y) = ∑(Yearly Revenue Growth Rates Over Last 1 Year) / 1
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the average revenue growth (1Y):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Revenue Growth (1Y) {'>'} 20%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_revenue_growth_1y > 20%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Revenue Growth (1Y) {'<='} 12%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_revenue_growth_1y <= 12%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Revenue Growth (1Y) {'>='} 15%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_revenue_growth_1y >= 15%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    By tracking Average Revenue Growth Over Last 1 Year, investors can gain insights into a company's growth momentum and operational effectiveness, aiding in the evaluation of the company's potential for future growth and profitability.
                </p>
            </div>
        ),
        'avg_revenue_growth_2y': (
            <div id="avg-revenue-growth-2y-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Average Revenue Growth (2Y)">
                <p className="text-lg font-semibold mb-4">Average Revenue Growth (2Y)</p>
                <p className="text-sm mb-4">
                    Average Revenue Growth Over Last 2 Years is a financial metric that measures the average year-over-year growth rate of a company's revenue over the most recent two-year period. This metric helps to smooth out fluctuations in revenue growth from one quarter to the next, providing a more consistent view of the company's growth trajectory.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Average Revenue Growth (2Y):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Average Revenue Growth (2Y) = ∑(Yearly Revenue Growth Rates Over Last 2 Years) / 2
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the average revenue growth (2Y):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Revenue Growth (2Y) {'>'} 25%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_revenue_growth_2y > 25%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Revenue Growth (2Y) {'<='} 18%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_revenue_growth_2y <= 18%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Revenue Growth (2Y) {'>='} 20%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_revenue_growth_2y >= 20%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    By tracking Average Revenue Growth Over Last 2 Years, investors can gain insights into a company's growth momentum and operational effectiveness, aiding in the evaluation of the company's potential for future growth and profitability.
                </p>
            </div>
        ),

        'avg_revenue_growth_3y': (
            <div id="avg-revenue-growth-3y-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Average Revenue Growth (3Y)">
                <p className="text-lg font-semibold mb-4">Average Revenue Growth (3Y)</p>
                <p className="text-sm mb-4">
                    Average Revenue Growth Over Last 3 Years is a financial metric that measures the average year-over-year growth rate of a company's revenue over the most recent three-year period. This metric helps to smooth out fluctuations in revenue growth from one quarter to the next, providing a more consistent view of the company’s growth trajectory.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Average Revenue Growth (3Y):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Average Revenue Growth (3Y) = ∑(Yearly Revenue Growth Rates Over Last 3 Years) / 3
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the average revenue growth (3Y):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Revenue Growth (3Y) {'>'} 30%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_revenue_growth_3y > 30%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Revenue Growth (3Y) {'<='} 25%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_revenue_growth_3y <= 25%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Revenue Growth (3Y) {'>='} 28%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_revenue_growth_3y >= 28%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    By tracking Average Revenue Growth Over Last 3 Years, investors can gain insights into a company’s growth momentum and operational effectiveness, aiding in the evaluation of the company's potential for future growth and profitability.
                </p>
            </div>
        ),
        'avg_revenue_growth_4y': (
            <div id="avg-revenue-growth-4y-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Average Revenue Growth (4Y)">
                <p className="text-lg font-semibold mb-4">Average Revenue Growth (4Y)</p>
                <p className="text-sm mb-4">
                    Average Revenue Growth Over Last 4 Years is a financial metric that measures the average year-over-year growth rate of a company's revenue over the most recent four-year period. This metric helps to smooth out fluctuations in revenue growth from one quarter to the next, providing a more consistent view of the company’s growth trajectory.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Average Revenue Growth (4Y):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Average Revenue Growth (4Y) = ∑(Yearly Revenue Growth Rates Over Last 4 Years) / 4
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the average revenue growth (4Y):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Revenue Growth (4Y) {'>'} 35%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_revenue_growth_4y > 35%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Revenue Growth (4Y) {'<='} 30%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_revenue_growth_4y <= 30%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Revenue Growth (4Y) {'>='} 32%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_revenue_growth_4y >= 32%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    By tracking Average Revenue Growth Over Last 4 Years, investors can gain insights into a company’s growth momentum and operational effectiveness, aiding in the evaluation of the company's potential for future growth and profitability.
                </p>
            </div>
        ),
        'avg_revenue_growth_5y': (
            <div id="avg-revenue-growth-5y-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Average Revenue Growth (5Y)">
                <p className="text-lg font-semibold mb-4">Average Revenue Growth (5Y)</p>
                <p className="text-sm mb-4">
                    Average Revenue Growth Over Last 5 Years is a financial metric that measures the average year-over-year growth rate of a company's revenue over the most recent five-year period. This metric helps to smooth out fluctuations in revenue growth from one quarter to the next, providing a more consistent view of the company’s growth trajectory.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Average Revenue Growth (5Y):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Average Revenue Growth (5Y) = ∑(Yearly Revenue Growth Rates Over Last 5 Years) / 5
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the average revenue growth (5Y):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Revenue Growth (5Y) {'>'} 40%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_revenue_growth_5y > 40%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Revenue Growth (5Y) {'<='} 35%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_revenue_growth_5y <= 35%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Revenue Growth (5Y) {'>='} 38%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_revenue_growth_5y >= 38%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    By tracking Average Revenue Growth Over Last 5 Years, investors can gain insights into a company’s growth momentum and operational effectiveness, aiding in the evaluation of the company's potential for future growth and profitability.
                </p>
            </div>
        ),
        'avg_net_income_growth_6q': (
            <div id="avg-net-income-growth-6q-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Average Net Income Growth (6Q)">
                <p className="text-lg font-semibold mb-4">Average Net Income Growth (6Q)</p>
                <p className="text-sm mb-4">
                    Average Net Income Growth Over Last 6 Quarters is a financial metric that measures the average quarter-over-quarter growth rate of a company's net income over the most recent six-quarter period. This metric helps to smooth out fluctuations in net income growth from one quarter to the next, providing a more consistent view of the company’s financial performance.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Average Net Income Growth (6Q):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Average Net Income Growth (6Q) = ∑(Quarterly Net Income Growth Rates Over Last 6 Quarters) / 6
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the average net income growth (6Q):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Net Income Growth (6Q) {'>'} 15%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_net_income_growth_6q > 15%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Net Income Growth (6Q) {'<='} 10%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_net_income_growth_6q <= 10%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Net Income Growth (6Q) {'>='} 12%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_net_income_growth_6q >= 12%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    By tracking Average Net Income Growth Over Last 6 Quarters, investors can gain insights into a company’s financial performance and profitability trends, aiding in the evaluation of the company's potential for future growth and investment returns.
                </p>
            </div>
        ),
        'avg_net_income_growth_4q': (
            <div id="avg-net-income-growth-4q-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Average Net Income Growth (4Q)">
                <p className="text-lg font-semibold mb-4">Average Net Income Growth (4Q)</p>
                <p className="text-sm mb-4">
                    Average Net Income Growth Over Last 4 Quarters is a financial metric that measures the average quarter-over-quarter growth rate of a company's net income over the most recent four-quarter period. This metric helps to smooth out fluctuations in net income growth from one quarter to the next, providing a more consistent view of the company’s financial performance.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Average Net Income Growth (4Q):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Average Net Income Growth (4Q) = ∑(Quarterly Net Income Growth Rates Over Last 4 Quarters) / 4
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the average net income growth (4Q):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Net Income Growth (4Q) {'>'} 20%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_net_income_growth_4q > 20%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Net Income Growth (4Q) {'<='} 15%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_net_income_growth_4q <= 15%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Net Income Growth (4Q) {'>'} 18%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_net_income_growth_4q >= 18%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    By tracking Average Net Income Growth Over Last 4 Quarters, investors can gain insights into a company’s financial performance and profitability trends, aiding in the evaluation of the company's potential for future growth and investment returns.
                </p>
            </div>
        ),
        'avg_net_income_growth_1y': (
            <div id="avg-net-income-growth-1y-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Average Net Income Growth (1Y)">
                <p className="text-lg font-semibold mb-4">Average Net Income Growth (1Y)</p>
                <p className="text-sm mb-4">
                    Average Net Income Growth Over Last 1 Year is a financial metric that measures the average year-over-year growth rate of a company's net income over the most recent twelve-month period. This metric helps to smooth out fluctuations in net income growth from one quarter to the next, providing a more consistent view of the company’s financial performance.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Average Net Income Growth (1Y):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Average Net Income Growth (1Y) = ∑(Yearly Net Income Growth Rates Over Last 1 Year) / 1
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the average net income growth (1Y):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Net Income Growth (1Y) {'>'} 25%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_net_income_growth_1y > 25%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Net Income Growth (1Y) {'<='} 20%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_net_income_growth_1y <= 20%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Net Income Growth (1Y) {'>='} 22%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_net_income_growth_1y >= 22%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    By tracking Average Net Income Growth Over Last 1 Year, investors can gain insights into a company’s financial performance and profitability trends, aiding in the evaluation of the company's potential for future growth and investment returns.
                </p>
            </div>
        ),
        'avg_net_income_growth_2y': (
            <div id="avg-net-income-growth-2y-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Average Net Income Growth (2Y)">
                <p className="text-lg font-semibold mb-4">Average Net Income Growth (2Y)</p>
                <p className="text-sm mb-4">
                    Average Net Income Growth Over Last 2 Years is a financial metric that measures the average year-over-year growth rate of a company's net income over the most recent two-year period. This metric helps to smooth out fluctuations in net income growth from one quarter to the next, providing a more consistent view of the company’s financial performance.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Average Net Income Growth (2Y):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Average Net Income Growth (2Y) = ∑(Yearly Net Income Growth Rates Over Last 2 Years) / 2
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the average net income growth (2Y):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Net Income Growth (2Y) {'>'} 30%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_net_income_growth_2y > 30%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Net Income Growth (2Y) {'<='} 25%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_net_income_growth_2y <= 25%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Net Income Growth (2Y) {'>='} 28%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_net_income_growth_2y >= 28%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    By tracking Average Net Income Growth Over Last 2 Years, investors can gain insights into a company’s financial performance and profitability trends, aiding in the evaluation of the company's potential for future growth and investment returns.
                </p>
            </div>
        ),
        'avg_net_income_growth_3y': (
            <div id="avg-net-income-growth-3y-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Average Net Income Growth (3Y)">
                <p className="text-lg font-semibold mb-4">Average Net Income Growth (3Y)</p>
                <p className="text-sm mb-4">
                    Average Net Income Growth Over Last 3 Years is a financial metric that measures the average year-over-year growth rate of a company's net income over the most recent three-year period. This metric helps to smooth out fluctuations in net income growth from one quarter to the next, providing a more consistent view of the company’s financial performance.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Average Net Income Growth (3Y):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Average Net Income Growth (3Y) = ∑(Yearly Net Income Growth Rates Over Last 3 Years) / 3
                </div>
                <p className="text-sm mb-4" >
                    Below are some sample queries related to the average net income growth (3Y):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Net Income Growth (3Y) {'>'} 35%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_net_income_growth_3y > 35%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Net Income Growth (3Y) {'<='} 30%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_net_income_growth_3y <= 30%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Net Income Growth (3Y) {'>='} 32%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_net_income_growth_3y >= 32%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    By tracking Average Net Income Growth Over Last 3 Years, investors can gain insights into a company’s financial performance and profitability trends, aiding in the evaluation of the company's potential for future growth and investment returns.
                </p>
            </div>
        ),
        'avg_net_income_growth_4y': (
            <div id="avg-net-income-growth-4y-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Average Net Income Growth (4Y)">
                <p className="text-lg font-semibold mb-4">Average Net Income Growth (4Y)</p>
                <p className="text-sm mb-4">
                    Average Net Income Growth Over Last 4 Years is a financial metric that measures the average year-over-year growth rate of a company's net income over the most recent four-year period. This metric helps to smooth out fluctuations in net income growth from one quarter to the next, providing a more consistent view of the company’s financial performance.
                </p>
                <p className="text-sm mb-4" >
                    Formula for calculating Average Net Income Growth (4Y):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Average Net Income Growth (4Y) = ∑(Yearly Net Income Growth Rates Over Last 4 Years) / 4
                </div>
                <p className="text-sm mb-4" >
                    Below are some sample queries related to the average net income growth (4Y):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Net Income Growth (4Y) {'>'} 40%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_net_income_growth_4y > 40%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Net Income Growth (4Y) {'<='} 35%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_net_income_growth_4y <= 35%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Net Income Growth (4Y) {'>='} 38%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_net_income_growth_4y >= 38%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    By tracking Average Net Income Growth Over Last 4 Years, investors can gain insights into a company’s financial performance and profitability trends, aiding in the evaluation of the company's potential for future growth and investment returns.
                </p>
            </div>
        ),
        'avg_net_income_growth_5y': (
            <div id="avg-net-income-growth-5y-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Average Net Income Growth (5Y)">
                <p className="text-lg font-semibold mb-4">Average Net Income Growth (5Y)</p>
                <p className="text-sm mb-4">
                    Average Net Income Growth Over Last 5 Years is a financial metric that measures the average year-over-year growth rate of a company's net income over the most recent five-year period. This metric helps to smooth out fluctuations in net income growth from one quarter to the next, providing a more consistent view of the company’s financial performance.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Average Net Income Growth (5Y):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Average Net Income Growth (5Y) = ∑(Yearly Net Income Growth Rates Over Last 5 Years) / 5
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the average net income growth (5Y):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Net Income Growth (5Y) {'>'} 45%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_net_income_growth_5y > 45%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Net Income Growth (5Y) {'<='} 40%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_net_income_growth_5y <= 40%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Net Income Growth (5Y) {'>='} 42%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_net_income_growth_5y >= 42%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    By tracking Average Net Income Growth Over Last 5 Years, investors can gain insights into a company’s financial performance and profitability trends, aiding in the evaluation of the company's potential for future growth and investment returns.
                </p>
            </div>
        ),
        'avg_gross_profit_growth_6q': (
            <div id="avg-gross-profit-growth-6q-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Average Gross Profit Growth (6Q)">
                <p className="text-lg font-semibold mb-4">Average Gross Profit Growth (6Q)</p>
                <p className="text-sm mb-4">
                    Average Gross Profit Growth Over Last 6 Quarters is a financial metric that measures the average quarter-over-quarter growth rate of a company's gross profit over the most recent six-quarter period. This metric helps to smooth out fluctuations in gross profit growth from one quarter to the next, providing a more consistent view of the company’s financial performance.
                </p>
                <p className="text-sm mb-4" >
                    Formula for calculating Average Gross Profit Growth (6Q):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Average Gross Profit Growth (6Q) = ∑(Quarterly Gross Profit Growth Rates Over Last 6 Quarters) / 6
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the average gross profit growth (6Q):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Gross Profit Growth (6Q) {'>'} 20%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_gross_profit_growth_6q > 20%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Gross Profit Growth (6Q) {'<='} 15%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_gross_profit_growth_6q <= 15%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Gross Profit Growth (6Q) {'>='} 18%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_gross_profit_growth_6q >= 18%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    By tracking Average Gross Profit Growth Over Last 6 Quarters, investors can gain insights into a company’s financial performance and profitability trends, aiding in the evaluation of the company's potential for future growth and investment returns.
                </p>
            </div>
        ),
        'avg_gross_profit_growth_4q': (
            <div id="avg-gross-profit-growth-4q-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Average Gross Profit Growth (4Q)">
                <p className="text-lg font-semibold mb-4">Average Gross Profit Growth (4Q)</p>
                <p className="text-sm mb-4">
                    Average Gross Profit Growth Over Last 4 Quarters is a financial metric that measures the average quarter-over-quarter growth rate of a company's gross profit over the most recent four-quarter period. This metric helps to smooth out fluctuations in gross profit growth from one quarter to the next, providing a more consistent view of the company’s financial performance.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Average Gross Profit Growth (4Q):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Average Gross Profit Growth (4Q) = ∑(Quarterly Gross Profit Growth Rates Over Last 4 Quarters) / 4
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the average gross profit growth (4Q):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Gross Profit Growth (4Q) {'>'} 25%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_gross_profit_growth_4q > 25%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Gross Profit Growth (4Q) {'<='} 20%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_gross_profit_growth_4q <= 20%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Gross Profit Growth (4Q) {'>='} 22%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_gross_profit_growth_4q >= 22%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    By tracking Average Gross Profit Growth Over Last 4 Quarters, investors can gain insights into a company’s financial performance and profitability trends, aiding in the evaluation of the company's potential for future growth and investment returns.
                </p>
            </div>
        ),
        'avg_gross_profit_growth_1y': (
            <div id="avg-gross-profit-growth-1y-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Average Gross Profit Growth (1Y)">
                <p className="text-lg font-semibold mb-4">Average Gross Profit Growth (1Y)</p>
                <p className="text-sm mb-4">
                    Average Gross Profit Growth Over Last 1 Year is a financial metric that measures the average year-over-year growth rate of a company's gross profit over the most recent twelve-month period. This metric helps to smooth out fluctuations in gross profit growth from one quarter to the next, providing a more consistent view of the company’s financial performance.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Average Gross Profit Growth (1Y):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Average Gross Profit Growth (1Y) = ∑(Yearly Gross Profit Growth Rates Over Last 1 Year) / 1
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the average gross profit growth (1Y):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Gross Profit Growth (1Y) {'>'} 30%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_gross_profit_growth_1y > 30%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Gross Profit Growth (1Y) {'<='} 25%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_gross_profit_growth_1y <= 25%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Gross Profit Growth (1Y) {'<='} 28%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_gross_profit_growth_1y >= 28%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    By tracking Average Gross Profit Growth Over Last 1 Year, investors can gain insights into a company’s financial performance and profitability trends, aiding in the evaluation of the company's potential for future growth and investment returns.
                </p>
            </div>
        ),
        'avg_gross_profit_growth_2y': (
            <div id="avg-gross-profit-growth-2y-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Average Gross Profit Growth (2Y)">
                <p className="text-lg font-semibold mb-4">Average Gross Profit Growth (2Y)</p>
                <p className="text-sm mb-4">
                    Average Gross Profit Growth Over Last 2 Years is a financial metric that measures the average year-over-year growth rate of a company's gross profit over the most recent two-year period. This metric helps to smooth out fluctuations in gross profit growth from one quarter to the next, providing a more consistent view of the company’s financial performance.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Average Gross Profit Growth (2Y):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Average Gross Profit Growth (2Y) = ∑(Yearly Gross Profit Growth Rates Over Last 2 Years) / 2
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the average gross profit growth (2Y):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Gross Profit Growth (2Y) {'>'} 35%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_gross_profit_growth_2y > 35%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Gross Profit Growth (2Y) {'<='} 30%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_gross_profit_growth_2y <= 30%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Gross Profit Growth (2Y) {'>='} 32%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_gross_profit_growth_2y >= 32%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    By tracking Average Gross Profit Growth Over Last 2 Years, investors can gain insights into a company’s financial performance and profitability trends, aiding in the evaluation of the company's potential for future growth and investment returns.
                </p>
            </div>
        ),
        'avg_gross_profit_growth_3y': (
            <div id="avg-gross-profit-growth-3y-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Average Gross Profit Growth (3Y)">
                <p className="text-lg font-semibold mb-4">Average Gross Profit Growth (3Y)</p>
                <p className="text-sm mb-4">
                    Average Gross Profit Growth Over Last 3 Years is a financial metric that measures the average year-over-year growth rate of a company's gross profit over the most recent three-year period. This metric helps to smooth out fluctuations in gross profit growth from one quarter to the next, providing a more consistent view of the company’s financial performance.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Average Gross Profit Growth (3Y):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Average Gross Profit Growth (3Y) = ∑(Yearly Gross Profit Growth Rates Over Last 3 Years) / 3
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the average gross profit growth (3Y):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Gross Profit Growth (3Y) {'>'} 40%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_gross_profit_growth_3y > 40%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Gross Profit Growth (3Y) {'<='} 35%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_gross_profit_growth_3y <= 35%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Gross Profit Growth (3Y) {'>='} 38%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_gross_profit_growth_3y >= 38%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    By tracking Average Gross Profit Growth Over Last 3 Years, investors can gain insights into a company’s financial performance and profitability trends, aiding in the evaluation of the company's potential for future growth and investment returns.
                </p>
            </div>
        ),
        'avg_gross_profit_growth_4y': (
            <div id="avg-gross-profit-growth-4y-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Average Gross Profit Growth (4Y)">
                <p className="text-lg font-semibold mb-4">Average Gross Profit Growth (4Y)</p>
                <p className="text-sm mb-4">
                    Average Gross Profit Growth Over Last 4 Years is a financial metric that measures the average year-over-year growth rate of a company's gross profit over the most recent four-year period. This metric helps to smooth out fluctuations in gross profit growth from one quarter to the next, providing a more consistent view of the company’s financial performance.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Average Gross Profit Growth (4Y):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Average Gross Profit Growth (4Y) = ∑(Yearly Gross Profit Growth Rates Over Last 4 Years) / 4
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the average gross profit growth (4Y):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Gross Profit Growth (4Y) {'>'} 45%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_gross_profit_growth_4y > 45%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Gross Profit Growth (4Y) {'<='} 40%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_gross_profit_growth_4y <= 40%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Gross Profit Growth (4Y) {'>='} 42%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_gross_profit_growth_4y >= 42%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    By tracking Average Gross Profit Growth Over Last 4 Years, investors can gain insights into a company’s financial performance and profitability trends, aiding in the evaluation of the company's potential for future growth and investment returns.
                </p>
            </div>
        ),
        'avg_gross_profit_growth_5y': (
            <div id="avg-gross-profit-growth-5y-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Average Gross Profit Growth (5Y)">
                <p className="text-lg font-semibold mb-4">Average Gross Profit Growth (5Y)</p>
                <p className="text-sm mb-4">
                    Average Gross Profit Growth Over Last 5 Years is a financial metric that measures the average year-over-year growth rate of a company's gross profit over the most recent five-year period. This metric helps to smooth out fluctuations in gross profit growth from one quarter to the next, providing a more consistent view of the company’s financial performance.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Average Gross Profit Growth (5Y):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Average Gross Profit Growth (5Y) = ∑(Yearly Gross Profit Growth Rates Over Last 5 Years) / 5
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the average gross profit growth (5Y):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Gross Profit Growth (5Y) {'>'} 50%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_gross_profit_growth_5y > 50%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Gross Profit Growth (5Y) {'<='} 45%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_gross_profit_growth_5y <= 45%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Average Gross Profit Growth (5Y) {'>='} 48%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('avg_gross_profit_growth_5y >= 48%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    By tracking Average Gross Profit Growth Over Last 5 Years, investors can gain insights into a company’s financial performance and profitability trends, aiding in the evaluation of the company's potential for future growth and investment returns.
                </p>
            </div>
        ),
        'total_acquired_1_month': (
            <div id="total-acquired-1-month-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Total Acquired (1 Month)">
                <p className="text-lg font-semibold mb-4">Total Acquired (1 Month)</p>
                <p className="text-sm mb-4">
                    Total Acquired (1 Month) refers to the total number of shares acquired by company insiders (such as executives, directors, and large shareholders) within a one-month period. This metric can indicate insider confidence in the company's future performance.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the total acquired (1 Month):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Acquired (1 Month) {'>'} 5000</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_acquired_1_month > 5000')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Acquired (1 Month) {'<='} 3000</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_acquired_1_month <= 3000')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Acquired (1 Month) {'>='} 4000</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_acquired_1_month >= 4000')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    Total Acquired (1 Month) for insider transactions provides valuable insights into the actions and confidence of insiders, which can serve as an indirect measure of the company's expected performance from the viewpoint of those closest to its internal workings.
                </p>
            </div>
        ),
        'total_acquired_2_month': (
            <div id="total-acquired-2-month-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Total Acquired (2 Month)">
                <p className="text-lg font-semibold mb-4">Total Acquired (2 Month)</p>
                <p className="text-sm mb-4">
                    Total Acquired (2 Month) refers to the total number of shares acquired by company insiders (such as executives, directors, and large shareholders) within a two-month period. This metric can indicate insider confidence in the company's future performance.
                </p>
                <p className="text-sm mb-4" >
                    Below are some sample queries related to the total acquired (2 Month):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Acquired (2 Month) {'>'} 7000</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_acquired_2_month > 7000')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Acquired (2 Month) {'<='} 5000</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_acquired_2_month <= 5000')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Acquired (2 Month) {'>='} 6000</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_acquired_2_month >= 6000')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    Total Acquired (2 Month) for insider transactions provides valuable insights into the actions and confidence of insiders, which can serve as an indirect measure of the company's expected performance from the viewpoint of those closest to its internal workings.
                </p>
            </div>
        ),
        'total_acquired_3_month': (
            <div id="total-acquired-3-month-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Total Acquired (3 Month)">
                <p className="text-lg font-semibold mb-4">Total Acquired (3 Month)</p>
                <p className="text-sm mb-4">
                    Total Acquired (3 Month) refers to the total number of shares acquired by company insiders (such as executives, directors, and large shareholders) within a three-month period. This metric can indicate insider confidence in the company's future performance.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the total acquired (3 Month):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Acquired (3 Month) {'>'} 9000</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_acquired_3_month > 9000')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Acquired (3 Month) {'<='} 7000</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_acquired_3_month <= 7000')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Acquired (3 Month) {'>='} 8000</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_acquired_3_month >= 8000')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    Total Acquired (3 Month) for insider transactions provides valuable insights into the actions and confidence of insiders, which can serve as an indirect measure of the company's expected performance from the viewpoint of those closest to its internal workings.
                </p>
            </div>
        ),
        'total_disposed_1_month': (
            <div id="total-disposed-1-month-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Total Disposed (1 Month)">
                <p className="text-lg font-semibold mb-4">Total Disposed (1 Month)</p>
                <p className="text-sm mb-4">
                    Total Disposed (1 Month) refers to the total number of shares disposed of by company insiders (such as executives, directors, and large shareholders) within a one-month period. This metric can indicate insider concerns about the company's future performance.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the total disposed (1 Month):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Disposed (1 Month) {'>'} 5000</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_disposed_1_month > 5000')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Disposed (1 Month) {'<='} 3000</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_disposed_1_month <= 3000')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    Total Disposed (1 Month) {'>='} 4000
                    <button className="rounded bg-black px-4 py-2 text-xs font-semibold text-white shadow-sm ml-5" onClick={() => onChildPropClick("total_disposed_1_month >= 4000")}>{filterButtonPlaceholder}</button>
                </div>
                <p className="text-sm mb-4">
                    Total Disposed (1 Month) for insider transactions provides valuable insights into the actions and concerns of insiders, which can serve as an indirect measure of the company's expected performance from the viewpoint of those closest to its internal workings.
                </p>
            </div>
        ),
        'total_disposed_2_month': (
            <div id="total-disposed-2-month-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Total Disposed (2 Month)">
                <p className="text-lg font-semibold mb-4">Total Disposed (2 Month)</p>
                <p className="text-sm mb-4">
                    Total Disposed (2 Month) refers to the total number of shares disposed of by company insiders (such as executives, directors, and large shareholders) within a two-month period. This metric can indicate insider concerns about the company's future performance.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the total disposed (2 Month):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Disposed (2 Month) {'>'} 7000</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_disposed_2_month > 7000')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Disposed (2 Month) {'<='} 5000</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_disposed_2_month <= 5000')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Disposed (2 Month) {'>='} 6000</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_disposed_2_month >= 6000')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    Total Disposed (2 Month) for insider transactions provides valuable insights into the actions and concerns of insiders, which can serve as an indirect measure of the company's expected performance from the viewpoint of those closest to its internal workings.
                </p>
            </div>
        ),
        'total_disposed_3_month': (
            <div id="total-disposed-3-month-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Total Disposed (3 Month)">
                <p className="text-lg font-semibold mb-4">Total Disposed (3 Month)</p>
                <p className="text-sm mb-4">
                    Total Disposed (3 Month) refers to the total number of shares disposed of by company insiders (such as executives, directors, and large shareholders) within a three-month period. This metric can indicate insider concerns about the company's future performance.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the total disposed (3 Month):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Disposed (3 Month) {'>'} 9000</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_disposed_3_month > 9000')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Disposed (3 Month) {'<='} 7000</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_disposed_3_month <= 7000')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Total Disposed (3 Month) {'>='} 8000</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('total_disposed_3_month >= 8000')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    Total Disposed (3 Month) for insider transactions provides valuable insights into the actions and concerns of insiders, which can serve as an indirect measure of the company's expected performance from the viewpoint of those closest to its internal workings.
                </p>
            </div>
        ),
        'free_cash_flow_avg_4q': (
            <div id="free-cash-flow-avg-4q-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Free Cash Flow Average (4Q)">
                <p className="text-lg font-semibold mb-4">Free Cash Flow Average (4Q)</p>
                <p className="text-sm mb-4">
                    Free Cash Flow Average (4Q) represents the average free cash flow generated by a company over the last four quarters. Free cash flow is the cash that a company generates after accounting for cash outflows to support operations and maintain its capital assets. It's a critical indicator of a company's financial health, reflecting its ability to generate cash and fund operations, debt payments, dividends, and growth initiatives.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Free Cash Flow Average (4Q):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    Free Cash Flow Average (4Q) = ∑(Quarterly Free Cash Flow Over Last 4 Quarters) / 4
                </div>
                <p className="text-sm mb-4" >
                    Below are some sample queries related to the free cash flow average (4Q):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Free Cash Flow Average (4Q) {'>'} 25K</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('free_cash_flow_avg_4q > 25k')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Free Cash Flow Average (4Q) {'<='} 2M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('free_cash_flow_avg_4q <= 2M')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Free Cash Flow Average (4Q) {'>='} 2.2M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('free_cash_flow_avg_4q >= 2.2M')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    Understanding Free Cash Flow Average (4Q) provides investors with insights into a company’s financial flexibility and its ability to generate cash that can be used for strategic initiatives, making it a valuable measure for assessing financial stability and growth potential.
                </p>
            </div>
        ),
        'free_cash_flow_avg_6q': (
            <div id="free-cash-flow-avg-6q-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Free Cash Flow Average (6Q)">
                <p className="text-lg font-semibold mb-4">Free Cash Flow Average (6Q)</p>
                <p className="text-sm mb-4">
                    Free Cash Flow Average (6Q) represents the average free cash flow generated by a company over the last six quarters. Free cash flow is the cash that a company generates after accounting for cash outflows to support operations and maintain its capital assets. It's a critical indicator of a company's financial health, reflecting its ability to generate cash and fund operations, debt payments, dividends, and growth initiatives.
                </p>
                <p className="text-sm mb-4">
                    Formula for calculating Free Cash Flow Average (6Q):
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Free Cash Flow Average (6Q) = ∑(Quarterly Free Cash Flow Over Last 6 Quarters) / 6
                </div>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the free cash flow average (6Q):
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Free Cash Flow Average (6Q) {'>'} 35K</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('free_cash_flow_avg_6q > 35K')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Free Cash Flow Average (6Q) {'<='} 3M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('free_cash_flow_avg_6q <= 3M')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Free Cash Flow Average (6Q) {'>='} 3.2M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('free_cash_flow_avg_6q >= 3.2M')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p>
                    Understanding Free Cash Flow Average (6Q) provides investors with insights into a company’s financial flexibility and its ability to generate cash that can be used for strategic initiatives, making it a valuable measure for assessing financial stability and growth potential.
                </p>
            </div>
        ),
        'revenue_last_quarter': (
            <div id="revenue-last-quarter-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Revenue Last Quarter">
                <p className="text-lg font-semibold mb-4">Revenue Last Quarter</p>
                <p className="text-sm mb-4">
                    Revenue Last Quarter refers to the total revenue generated by a company in the most recent quarter. Revenue is a key financial metric that reflects a company's ability to generate sales from its core business operations. It provides insights into the company's growth, market demand, and sales performance.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the revenue last quarter:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Revenue Last Quarter {'>'} 1B</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('revenue_last_quarter > 1B')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Revenue Last Quarter {'<='} 8M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('revenue_last_quarter <= 8M')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Revenue Last Quarter {'>='} 9M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('revenue_last_quarter >= 9M')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p>
                    By tracking Revenue Last Quarter, investors can gain insights into a company’s recent sales performance and revenue trends, aiding in the evaluation of the company's growth potential and investment returns.
                </p>
            </div>
        ),
        'net_income_last_quarter': (
            <div id="net-income-last-quarter-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Net Income Last Quarter">
                <p className="text-lg font-semibold mb-4">Net Income Last Quarter</p>
                <p className="text-sm mb-4">
                    Net Income Last Quarter refers to the total net income generated by a company in the most recent quarter. Net income is a key financial metric that reflects a company's profitability after accounting for all expenses, taxes, and interest payments. It provides insights into the company's financial performance and bottom-line results.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the net income last quarter:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Net Income Last Quarter {'>'} 5M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('net_income_last_quarter > 5M')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Net Income Last Quarter {'<='} 40M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('net_income_last_quarter <= 40M')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Net Income Last Quarter {'>='} 4B</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('net_income_last_quarter >= 4B')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p>
                    By tracking Net Income Last Quarter, investors can gain insights into a company’s recent profitability and earnings trends, aiding in the evaluation of the company's financial performance and investment returns.
                </p>
            </div>
        ),
        'gross_profit_last_quarter': (
            <div id="gross-profit-last-quarter-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Gross Profit Last Quarter">
                <p className="text-lg font-semibold mb-4">Gross Profit Last Quarter</p>
                <p className="text-sm mb-4">
                    Gross Profit Last Quarter refers to the total gross profit generated by a company in the most recent quarter. Gross profit is a key financial metric that reflects the difference between revenue and the cost of goods sold (COGS). It provides insights into the company's pricing strategy, production efficiency, and profitability.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the gross profit last quarter:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Gross Profit Last Quarter {'>'} 10M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('gross_profit_last_quarter > 10M')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Gross Profit Last Quarter {'<='} 8M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('gross_profit_last_quarter <= 8M')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Gross Profit Last Quarter {'>='} 9M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('gross_profit_last_quarter >= 9M')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p>
                    By tracking Gross Profit Last Quarter, investors can gain insights into a company’s recent profitability and production efficiency, aiding in the evaluation of the company's financial performance and investment returns.
                </p>
            </div>
        ),
        'revenue_ttm': (
            <div id="revenue-ttm-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Revenue TTM">
                <p className="text-lg font-semibold mb-4">Revenue TTM</p>
                <p className="text-sm mb-4">
                    Revenue TTM refers to the total revenue generated by a company over the trailing twelve months (TTM). Revenue is a key financial metric that reflects a company's ability to generate sales from its core business operations. It provides insights into the company's growth, market demand, and sales performance.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the revenue TTM:
                </p>


                <h3 className="text-sm mb-4 font-bold">
                    TTM: Total Trailing 12 Months
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Revenue TTM {'>'} 100M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('revenue_ttm > 100M')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    CAGR: Compound Annual Growth Rate
                </h3>

                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Revenue Growth - past 3 years, CAGR {'>'} 2%</span>

                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('revenue_growth_past_3_years_cagr > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Average: Average Revenue Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Revenue Growth - past 3 years, Average {'>'} 2%</span>

                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('revenue_growth_past_3_years_average > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                    Total: Total Revenue growth achieved
                </h3>

                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Revenue Growth - past 3 years, Total {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('revenue_growth_past_3_years_total > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                    Has Improved: Has Improved Revenue Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Has Revenue turned around - past 3 years = True</span>

                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('has_revenue_turned_around_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                    Growth Estimate: Projected revenue growth rate
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Revenue Growth Estimate (next 3 years) {'>'} 2%</span>

                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('revenue_growth_estimate_next_3_years > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p>
                    By tracking Revenue TTM, investors can gain insights into a company’s recent sales performance and revenue trends, aiding in the evaluation of the company's growth potential and investment returns.
                </p>
            </div>
        ),
        'net_income_ttm': (
            <div id="net-income-ttm-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Net Income TTM">
                <p className="text-lg font-semibold mb-4">Net Income TTM</p>
                <p className="text-sm mb-4">
                    Net Income TTM refers to the total net income generated by a company over the trailing twelve months (TTM). Net income is a key financial metric that reflects a company's profitability after accounting for all expenses, taxes, and interest payments. It provides insights into the company's financial performance and bottom-line results.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the net income:
                </p>
                <h3 className="text-sm mb-4 font-bold">
                    TTM: Total Trailing 12 Months
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Net Income TTM {'>'} 50M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('net_income_ttm > 50M')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                    CAGR: Compound Annual Growth Rate
                </h3>

                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Net Income Growth - past 3 years, CAGR {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('net_income_growth_past_3_years_cagr > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                    Average: Average Net Income Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Net Income Growth - past 3 years, Average {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('net_income_growth_past_3_years_average > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>


                <h3 className="text-sm mb-4 font-bold">
                    Total: Total net income growth achieved
                </h3>

                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Net Income Growth - past 3 years, Total {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('net_income_growth_past_3_years_total > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                    Has Improved: Has Improved Net Income Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Has Net Income turned around - past 3 years = True</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('has_net_income_turned_around_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <p className="text-sm mb-4">
                    By tracking Net Income TTM, investors can gain insights into a company’s recent profitability and earnings trends, aiding in the evaluation of the company's financial performance and investment returns.
                </p>
            </div>
        ),
        'gross_profit_ttm': (
            <div id="gross-profit-ttm-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Gross Profit TTM">
                <p className="text-lg font-semibold mb-4">Gross Profit TTM</p>
                <p className="text-sm mb-4">
                    Gross Profit TTM refers to the total gross profit generated by a company over the trailing twelve months (TTM). Gross profit is a key financial metric that reflects the difference between revenue and the cost of goods sold (COGS). It provides insights into the company's pricing strategy, production efficiency, and profitability.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the gross profit TTM:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Gross Profit TTM {'>'} 100M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('gross_profit_ttm > 10M')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Gross Profit TTM {'<='} 8M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('gross_profit_ttm <= 8M')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Gross Profit TTM {'>='} 90M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('gross_profit_ttm >= 90M')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    By tracking Gross Profit TTM, investors can gain insights into a company’s recent profitability and production efficiency, aiding in the evaluation of the company's financial performance and investment returns.
                </p>
            </div>
        ),
        'recent_insider_activity': (
            <div id="recent-insider-activity-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Recent Insider Activity">
                <p className="text-lg font-semibold mb-4">Recent Insider Activity</p>
                <p className="text-sm mb-4">
                    Recent Insider Activity refers to BUY or SELL based on the insider transactions reported by company insiders (such as executives, directors, and large shareholders) in the last 3 months.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the recent insider activity:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Recent Insider Activity: BUY</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('recent_insider_activity = BUY')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Recent Insider Activity: SELL</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('recent_insider_activity = SELL')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    Knowing the Recent Insider Activity can provide valuable insights into the actions and sentiment of insiders, which can serve as an indirect measure of the company's expected performance from the viewpoint of those closest to its internal workings.
                </p>
            </div>
        ),
        'ipo_year': (
            <div id="ipo-year-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="IPO Year">
                <p className="text-lg font-semibold mb-4">IPO Year</p>
                <p className="text-sm mb-4">
                    IPO Year refers to the year in which a company conducted its initial public offering (IPO) and became a publicly traded company. The IPO year is a key milestone in a company's history, marking its transition from a private entity to a publicly listed corporation.
                </p>
                <p className="text-sm mb-4">
                    Below are some sample queries related to the IPO year:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>IPO Year: 2020</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('ipo_year = 2020')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>IPO Year: 2019</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('ipo_year = 2019')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>IPO Year: 2018</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('ipo_year = 2018')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    Understanding the IPO Year of a company can provide insights into its history, growth trajectory, and market performance since becoming a publicly traded entity.
                </p>
            </div>
        ),
        'revenue_growth_past_3_years_total': (
            <div id="revenue-growth-past-3-years-total-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Revenue Growth Past 3 Years Total">
                <p className="text-lg font-semibold mb-4">Revenue Growth Past 3 Years Total</p>
                <p className="text-sm mb-4">
                    Revenue Growth Past 3 Years Total refers to the total growth in a company's revenue over the past three years, expressed as a percentage.
                </p>
                <p className="text-sm mb-4">
                    The formula for calculating market cap is:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Revenue Growth (3 Years) = Revenue at End of 3 Years - Revenue at Start of 3 Years/Revenue at Start of 3 Years * 100

                </div>
                <p className="text-sm mb-4">
                    Below are the sample queries for market cap:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Revenue Growth - past 3 years, Total {'>='} 5%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('revenue_growth_past_3_years_total >= 5%')}
                    >{filterButtonPlaceholder}</Button>

                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Revenue Growth - past 3 years, Total {'>='} 10%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('revenue_growth_past_3_years_total >= 10%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Revenue Growth - past 3 years, Total {'>='} 15%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('revenue_growth_past_3_years_total >= 15%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    Revenue growth is a key indicator of a company's ability to expand its operations and generate higher sales. This filter evaluates the total growth in revenue over a three-year period, providing insights into the company's long-term growth trajectory. A consistent increase in revenue over multiple years often reflects a strong business model, market demand, and effective management strategies. Conversely, stagnant or declining revenue could indicate challenges in maintaining market share or operational inefficiencies.
                </p>

                <p className="text-sm mb-4">
                    This metric is particularly useful for identifying growth-oriented companies and assessing their potential for future expansion. It is commonly used by investors focusing on growth stocks or evaluating the financial health of companies in competitive industries.
                </p>
            </div>
        ),
        'net_income_growth_past_year': (
            <div id="revenue-growth-past-3-years-total-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Revenue Growth Past 3 Years Total">
                <p className="text-lg font-semibold mb-4">Revenue Growth Past 3 Years Total</p>
                <p className="text-sm mb-4">
                    This filter measures the percentage change in a company's net income over the past year, reflecting its profitability growth on a year-over-year basis.
                </p>
                <p className="text-sm mb-4">
                    The formula for calculating Net Income Growth is:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Net Income Growth (Past Year) = Net Income (Current Year) - Net Income (Previous Year) / Net Income (Previous Year) * 100
                </div>
                <p className="text-sm mb-4">
                    Below are the sample queries for market cap:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Net Income Growth - past year, Total {'>='} 400M</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('net_income_growth_past_year >= 400M')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Net Income Growth - past year, Total {'>='} 10B</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('net_income_growth_past_year >= 10B')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Net Income Growth - past year, Total {'>='} 15B</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('net_income_growth_past_year >= 15B')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    Net income growth is a critical indicator of a company's ability to increase its profits over time. This filter evaluates how much the company's net income has grown (or declined) compared to the previous year. A positive growth rate suggests improving profitability, which could result from higher revenues, cost efficiency, or improved operational management. Conversely, a negative growth rate may indicate declining profitability, potential financial challenges, or increased costs.
                </p>

                <p className="text-sm mb-4">
                    Investors use this metric to identify companies with strong and consistent earnings growth. It is particularly useful for evaluating companies in industries where profitability is a key driver of stock performance.
                </p>
            </div>
        ),
        'shares_short_float_percentage': (
            <div id="shares-short-float-percentage-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Shares Short Float Percentage">
                <p className="text-lg font-semibold mb-4">Shares Short Float Percentage</p>
                <p className="text-sm mb-4">
                    The percentage of a company's total publicly traded shares (float) that are currently sold short by investors.
                </p>
                <p className="text-sm mb-4">
                    The formula for calculating Shares Short Float Percentage is:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Shares Short Float Percentage = Shares Sold Short /Total Float Shares * 100
                </div>
                <p className="text-sm mb-4">
                    Below are the sample queries for market cap:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Shares Short Float Percentage {'>='} 50%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('shares_short_float_percentage >= 50%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Shares Short Float Percentage {'>='} 10%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('shares_short_float_percentage >= 10%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Shares Short Float Percentage {'>='} 15%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('shares_short_float_percentage >= 15%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <p className="text-sm mb-4">
                    This filter measures the level of bearish sentiment among investors. A high short float percentage indicates that a significant portion of investors believe the stock's price will decline. Conversely, a low percentage suggests limited bearish sentiment. This metric is often used to identify stocks with potential for a short squeeze, where a rapid price increase forces short sellers to cover their positions, driving prices even higher.
                </p>

                <p className="text-sm mb-4">
                    It is a key indicator of market sentiment and is typically used in combination with other metrics to gauge investor confidence in a stock.
                </p>
            </div>
        ),
        'free_cash_flow_ttm': (
            <div id="free-cash-flow-ttm-info-section" className="education-info-section mb-5 text-gray-700" data-suggest-name="Free Cash Flow TTM">
                <p className="text-lg font-semibold mb-4">Free Cash Flow TTM</p>
                <p className="text-sm mb-4">
                    Free Cash Flow TTM refers to the trailing twelve months' (TTM) free cash flow, which is a measure of a company's cash flow from operations after accounting for capital expenditures.
                </p>
                <p className="text-sm mb-4">
                    The formula for calculating Free Cash Flow TTM is:
                </p>
                <div className="bg-blue-100 text-black p-3 rounded-md m-4 text-sm font-medium">
                    Free Cash Flow TTM = Net Income + Depreciation & Amortization + Changes in Working Capital - Capital Expenditures
                </div>
                <p className="text-sm mb-4">
                    Below are the sample queries for Free Cash Flow TTM:
                </p>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Free Cash Flow TTM {'>='} 50%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('free_cash_flow_ttm >= 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    CAGR: Compound Annual Growth Rate
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Free Cash Flow Growth - past 3 years, CAGR {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('free_cash_flow_growth_past_3_years_cagr > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Average: Average Free Cash Flow Growth
                </h3>

                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Free Cash Flow Growth - past 3 years, Average {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('free_cash_flow_growth_past_3_years_average > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>
                <h3 className="text-sm mb-4 font-bold">
                    Total: Total Free Cash Flow growth achieved
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Free Cash Flow Growth - past 3 years, Total {'>'} 2%</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('free_cash_flow_growth_past_3_years_total > 2%')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                    Has Turned Around: Has Improved Free Cash Flow Growth
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Has Free Cash Flow growth turned around - past 3 years = True</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('has_free_cash_flow_turned_around_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <h3 className="text-sm mb-4 font-bold">
                Postive Free Cash Flow: Has positive free cash flow over the years
                </h3>
                <div className="rounded-md bg-green-100 py-3 px-2 m-4 text-sm font-medium flex justify-between">
                    <span>Postive Free Cash Flow - past 3 years = True</span>
                    <Button
                        type="primary"
                        size="xs"
                        onClick={() => onChildPropClick('is_free_cash_flow_positive_past_3_years = True')}
                    >{filterButtonPlaceholder}</Button>
                </div>

                <p className="text-sm mb-4">
                    This filter measures the level of bearish sentiment among investors. A high short float percentage indicates that a significant portion of investors believe the stock's price will decline. Conversely, a low percentage suggests limited bearish sentiment. This metric is often used to identify stocks with potential for a short squeeze, where a rapid price increase forces short sellers to cover their positions, driving prices even higher.
                </p>

                <p className="text-sm mb-4">
                    It is a key indicator of market sentiment and is typically used in combination with other metrics to gauge investor confidence in a stock.
                </p>
            </div>
        ),
    }

    return (
        <Transition show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={handleClose}>
                <TransitionChild
                    enter="ease-in-out duration-500"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-500"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </TransitionChild>

                <div className="fixed inset-0 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
                            <TransitionChild
                                enter="transform transition ease-in-out duration-500"
                                enterFrom="translate-x-full"
                                enterTo="translate-x-0"
                                leave="transform transition ease-in-out duration-500"
                                leaveFrom="translate-x-0"
                                leaveTo="translate-x-full"
                            >
                                <DialogPanel className="pointer-events-auto w-screen max-w-[100%] md:max-w-lg">
                                    <div className="flex h-full flex-col bg-white shadow-xl">
                                        <div className="sticky top-0 z-10 bg-white">
                                            <div className="px-4 py-5 sm:px-6">
                                                <div className="flex justify-between items-center">
                                                    <DialogTitle className="text-lg font-semibold">
                                                        Filters
                                                    </DialogTitle>
                                                    <button
                                                        type="button"
                                                        className="text-gray-900 hover:text-gray-700"
                                                        onClick={handleClose}
                                                    >
                                                        <FontAwesomeIcon icon={faCircleXmark} className="h-6 w-6" aria-hidden="true" />
                                                        <span className="sr-only">Close panel</span>
                                                    </button>

                                                </div>
                                                <hr className="mt-2" />


                                                <div className="my-4 max-w-md mx-auto relative ">
                                                    <div className="relative" >
                                                        <FontAwesomeIcon
                                                            icon={faMagnifyingGlass}
                                                            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 h-5 w-5"
                                                        />
                                                        <input
                                                            type="text"
                                                            id="inputInCompB"
                                                            className="w-full mx-auto block px-3 py-3 pr-10 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-green-700 focus:border-transparent"
                                                            placeholder="Select a filter to see examples"
                                                            ref={inputRef}
                                                            value={filterTextBoxQueryValue}
                                                            onChange={handleFilterQueryChange}
                                                            onKeyDown={handleKeyDown}
                                                            onBlur={handleOnBlur}
                                                            onFocus={() => setShowFilterSuggestions(true)}
                                                            autoComplete="off"
                                                            autoCorrect="off"
                                                            aria-label="Search" />

                                                    </div>
                                                    {/* <div className="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                                                        <div className="relative flex justify-center py-3">
                                                            <div className="relative ">
                                                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                                    <FontAwesomeIcon icon={faMagnifyingGlass} className="h-4 w-4 text-gray-400" />
                                                                </div>
                                                                <input
                                                                    type="text"
                                                                    id="inputInCompB"
                                                                    className="w-full mx-auto block px-3 py-3 pr-10 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-green-700 focus:border-transparent"
                                                                    placeholder="Select a filter to see examples"
                                                                    ref={inputRef}
                                                                    value={filterTextBoxQueryValue}
                                                                    onChange={handleFilterQueryChange}
                                                                    onKeyDown={handleKeyDown}
                                                                    onBlur={handleOnBlur}
                                                                    onFocus={() => setShowFilterSuggestions(true)}
                                                                    autoComplete="off"
                                                                    autoCorrect="off"
                                                                    aria-label="Search"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div> */}

                                                    {(showFilterSuggestions && narrowedSuggestions.length > 0) && (
                                                        <div className="absolute left-2 right-2 lg:left-4 lg:right-4 mt-1 bg-white rounded-lg shadow-lg border border-gray-200 z-10 max-h-[300px] overflow-y-scroll [&::-webkit-scrollbar]:block [&::-webkit-scrollbar]:w-[5px] md:[&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:bg-gray-400 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 suggestions-list">
                                                            {narrowedSuggestions.map((suggestion, index) => (
                                                                <div
                                                                    key={index}
                                                                    className={`px-3 py-4 hover:bg-gray-100 cursor-pointer border-b last:border-b-0 ${activeSuggestion === index ? 'bg-gray-50' : ''
                                                                        }`}
                                                                    onClick={() => handleSuggestionClick(suggestion)}

                                                                >
                                                                    <div className="space-y-2 text-start">
                                                                        <div className="flex items-center justify-between">
                                                                            <div>
                                                                                <span className="text-sm font-semibold text-gray-900 me-3">{suggestion.name}</span>
                                                                                <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                                                                                    {suggestion.key}
                                                                                </span>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}

                                                </div>
                                                <div className="mt-5 overflow-y-auto" style={{ maxHeight: 'calc(100vh - 200px)' }}>

                                                    {sections[filterQueryValue as keyof typeof sections] || null}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </DialogPanel>
                            </TransitionChild>
                        </div>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
}; 